import axios from 'axios';
import router from "@/router";
import { configurations } from './configurations.module';

let state = {
    loadCables: false,

    cables_Data: {},

    /* loader_forLoadingAllContent_at_cable_Shown: false,*/
    babl: false,
    encoderCableDeliverSelection: [],

    encoderConnectionInformation: {},
    encoderCableLengthSelection: [],
    motorCableLengthSelection: [],
    motorProtectionCableLengthSelection: [],
    brakeCableLengthSelection: [],
    brakeMonitoringCableLengthSelection: [],
    forcedVentilationCableLengthSelection: [],

    encoderCableTypeOfConnectionOnComponentSideSelection: [],
    motorCableTypeOfConnectionOnComponentSideSelection: [],
    motorProtectionCableTypeOfConnectionOnComponentSideSelection: [],
    brakeCableTypeOfConnectionOnComponentSideSelection: [],
    brakeMonitoringCableTypeOfConnectionOnComponentSideSelection: [],
    forcedVentilationCableTypeOfConnectionOnComponentSideSelection: [],

    encoderCableSpecificationSelection: [],
    motorCableSpecificationSelection: [],
    motorProtectionCableSpecificationSelection: [],
    brakeCableSpecificationSelection: [],
    brakeMonitoringCableSpecificationSelection: [],
    forcedVentilationCableSpecificationSelection: [],

    encoderCableNumberOfWiresAndCrossSectionSelection: [],
    motorCableNumberOfWiresAndCrossSectionSelection: [],
    motorProtectionCableNumberOfWiresAndCrossSectionSelection: [],
    brakeCableNumberOfWiresAndCrossSectionSelection: [],
    brakeMonitoringCableNumberOfWiresAndCrossSectionSelection: [],
    forcedVentilationCableNumberOfWiresAndCrossSectionSelection: [],

    encoderCableBlockNumberSelection: [],
    motorCableBlockNumberSelection: [],
    motorProtectionCableBlockNumberSelection: [],
    brakeCableBlockNumberSelection: [],
    brakeMonitoringCableBlockNumberSelection: [],
    forcedVentilationCableBlockNumberSelection: [],

    defaultLengthValue: null,
    userSelectedLengthEncoderCable: false,
    userSelectedLengthMotorCable: false,
    userSelectedLengthMotorProtectionCable: false,
    userSelectedLengthBrakeCable: false,
    userSelectedLengthBrakeMonitoringCable: false,
    userSelectedLengthForcedVentilationCable: false

}

const actions = {
    change_cablesManual_toDefault_storeAction({ commit, dispatch }) {
        commit('change_loadCables_storeMutation', false);
        commit('change_cables_Data_storeMutation', {});

        commit('change_encoderCableDeliverSelection_storeMutation', []);

        commit('change_encoderConnectionInformation_storeMutation', {});
        commit('change_encoderCableLengthSelection_storeMutation', []);
        commit('change_motorCableLengthSelection_storeMutation', []);
        commit('change_motorProtectionCableLengthSelection_storeMutation', []);
        commit('change_brakeCableLengthSelection_storeMutation', []);
        commit('change_brakeMonitoringCableLengthSelection_storeMutation', []);
        commit('change_forcedVentilationCableLengthSelection_storeMutation', []);

        commit('change_encoderCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        commit('change_motorCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        commit('change_motorProtectionCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        commit('change_brakeCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        commit('change_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        commit('change_forcedVentilationCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);

        commit('change_encoderCableSpecificationSelection_storeMutation', []);
        commit('change_motorCableSpecificationSelection_storeMutation', []);
        commit('change_motorProtectionCableSpecificationSelection_storeMutation', []);
        commit('change_brakeCableSpecificationSelection_storeMutation', []);
        commit('change_brakeMonitoringCableSpecificationSelection_storeMutation', []);
        commit('change_forcedVentilationCableSpecificationSelection_storeMutation', []);

        commit('change_encoderCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        commit('change_motorCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        commit('change_motorProtectionCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        commit('change_brakeCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        commit('change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        commit('change_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);

        commit('change_encoderCableBlockNumberSelection_storeMutation', []);
        commit('change_motorCableBlockNumberSelection_storeMutation', []);
        commit('change_motorProtectionCableBlockNumberSelection_storeMutation', []);
        commit('change_brakeCableBlockNumberSelection_storeMutation', []);
        commit('change_babl_storeMutation', false);
        commit('change_brakeMonitoringCableBlockNumberSelection_storeMutation', []);
        commit('change_forcedVentilationCableBlockNumberSelection_storeMutation', []);

        commit('changed_defaultLengthValue_storeMutation', null);
        commit('changed_userSelectedLengthEncoderCable_storeMutation', false);
        commit('changed_userSelectedLengthMotorCable_storeMutation', false);
        commit('changed_userSelectedLengthMotorProtectionCable_storeMutation', false);
        commit('changed_userSelectedLengthBrakeCable_storeMutation', false);
        commit('changed_userSelectedLengthBrakeMonitoringCable_storeMutation', false);
        commit('changed_userSelectedLengthForcedVentilationCable_storeMutation', false);
    },


    // Manual selection
    async get_cableInformationsManual_storeAction({ commit, dispatch, rootState }) {
        if (rootState.manualHome.configurationOverviewsManualId != null) {
            if (rootState.inputsManual.motorCablesManualData != null && rootState.inputsManual.motorCablesManualData.hasOwnProperty('details')) {
                commit('changed_userSelectedLengthMotorCable_storeMutation', true);
                commit('changed_userSelectedLengthMotorProtectionCable_storeMutation', true);
                commit('changed_userSelectedLengthBrakeCable_storeMutation', true);
                commit('changed_userSelectedLengthBrakeMonitoringCable_storeMutation', true);
                commit('changed_userSelectedLengthForcedVentilationCable_storeMutation', true);
            }

            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

            const data = {
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/cables/get_cableInformationsManual',
                data: {
                    data: data,
                }
            })
                .then((response) => {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                    commit('change_loadCables_storeMutation', true);
                    if ((response.data.status.statusCode.substring(0, 1) == '2') || (response.data.status.statusCode.substring(0, 2) == '74') || (response.data.status.statusCode.substring(0, 2) == '75')) {

                        commit('change_cables_Data_storeMutation', response.data.data);
                        var firstIndex_whichMeetConditions_motorCableDeliver = state.cables_Data.motorCable_DeliverOption_Valuelist.findIndex(i => (i.selected == true));
                        if (state.loadCables == true && rootState.summary.manualHomeSummary != null && rootState.summary.manualHomeSummary.hasOwnProperty('cables') && state.cables_Data.motorCable_DeliverOption_Valuelist != null && state.cables_Data.motorCable_DeliverOption_Valuelist.hasOwnProperty('text') == true) {
                            const loadMotorCables = state.cables_Data.motorCable_DeliverOption_Valuelist.findIndex(i => (i.text.text == rootState.summary.manualHomeSummary.cables.motorCableDeliverOption));
                            if (loadMotorCables > -1) {
                                firstIndex_whichMeetConditions_motorCableDeliver = loadMotorCables;
                            }
                        }
                        if (firstIndex_whichMeetConditions_motorCableDeliver > -1) {
                            dispatch('change_motorCableDeliver_storeAction', state.cables_Data.motorCable_DeliverOption_Valuelist[firstIndex_whichMeetConditions_motorCableDeliver])
                        }
                        else {
                            dispatch('change_motorCableDeliver_storeAction', null)
                        }
                        var firstIndex_whichMeetConditions_motorProtectionCableDeliver = state.cables_Data.motorProtectionCable_DeliverOption_Valuelist.findIndex(i => (i.selected == true));
                        if (state.loadCables == true && rootState.summary.manualHomeSummary != null && rootState.summary.manualHomeSummary.hasOwnProperty('cables') && state.cables_Data.motorProtectionCable_DeliverOption_Valuelist != null && state.cables_Data.motorProtectionCable_DeliverOption_Valuelist.hasOwnProperty('text') == true) {
                            const loadMotorProtectionCables = state.cables_Data.motorProtectionCable_DeliverOption_Valuelist.findIndex(i => (i.text.text == rootState.summary.manualHomeSummary.cables.motorProtectionCableDeliverOption));
                            if (loadMotorProtectionCables > -1) {
                                firstIndex_whichMeetConditions_motorProtectionCableDeliver = loadMotorProtectionCables;
                            }
                        }
                        if (firstIndex_whichMeetConditions_motorProtectionCableDeliver > -1) {
                            dispatch('change_motorProtectionCableDeliver_storeAction', state.cables_Data.motorProtectionCable_DeliverOption_Valuelist[firstIndex_whichMeetConditions_motorProtectionCableDeliver])
                        }
                        else {
                            dispatch('change_motorProtectionCableDeliver_storeAction', null)
                        }
                        var firstIndex_whichMeetConditions_brakeCableDeliver = state.cables_Data.brakeCable_DeliverOption_Valuelist.findIndex(i => (i.selected == true));
                        if (state.loadCables == true && rootState.summary.manualHomeSummary != null && rootState.summary.manualHomeSummary.hasOwnProperty('cables') && state.cables_Data.brakeCable_DeliverOption_Valuelist != null && state.cables_Data.brakeCable_DeliverOption_Valuelist.hasOwnProperty('text') == true) {
                            const loadBrakeCables = state.cables_Data.brakeCable_DeliverOption_Valuelist.findIndex(i => (i.text.text == rootState.summary.manualHomeSummary.cables.brakeCableDeliverOption));
                            if (loadBrakeCables > -1) {
                                firstIndex_whichMeetConditions_brakeCableDeliver = loadBrakeCables;
                            }
                        }
                        if (firstIndex_whichMeetConditions_brakeCableDeliver > -1) {
                            dispatch('change_brakeCableDeliver_storeAction', state.cables_Data.brakeCable_DeliverOption_Valuelist[firstIndex_whichMeetConditions_brakeCableDeliver])
                        }
                        else {
                            dispatch('change_brakeCableDeliver_storeAction', null)
                        }
                        var firstIndex_whichMeetConditions_brakeMonitoringCableDeliver = state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist.findIndex(i => (i.selected == true));
                        if (state.loadCables == true && rootState.summary.manualHomeSummary != null && rootState.summary.manualHomeSummary.hasOwnProperty('cables') && state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist != null && state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist.hasOwnProperty('text') == true) {
                            const loadBrakeMonitoringCables = state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist.findIndex(i => (i.text.text == rootState.summary.manualHomeSummary.cables.brakeMonitoringCable_DeliverOption_Valuelist));
                            if (loadBrakeMonitoringCables > -1) {
                                firstIndex_whichMeetConditions_brakeMonitoringCableDeliver = loadBrakeMonitoringCables;
                            }
                        }
                        if (firstIndex_whichMeetConditions_brakeMonitoringCableDeliver > -1) {
                            dispatch('change_brakeMonitoringCableDeliver_storeAction', state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist[firstIndex_whichMeetConditions_brakeMonitoringCableDeliver])
                        }
                        else {
                            dispatch('change_brakeMonitoringCableDeliver_storeAction', null)
                        }
                        var firstIndex_whichMeetConditions_forcedVentilationCableDeliver = state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist.findIndex(i => (i.selected == true));
                        if (state.loadCables == true && rootState.summary.manualHomeSummary != null && rootState.summary.manualHomeSummary.hasOwnProperty('cables') && state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist != null && state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist.hasOwnProperty('text') == true) {
                            const loadForcedVentilationCables = state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist.findIndex(i => (i.text.text == rootState.summary.manualHomeSummary.cables.forcedVentilationCable_DeliverOption_Valuelist));
                            if (loadForcedVentilationCables > -1) {
                                firstIndex_whichMeetConditions_forcedVentilationCableDeliver = loadForcedVentilationCables;
                            }
                        }
                        if (firstIndex_whichMeetConditions_forcedVentilationCableDeliver > -1) {
                            dispatch('change_forcedVentilationCableDeliver_storeAction', state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist[firstIndex_whichMeetConditions_forcedVentilationCableDeliver])
                        }
                        else {
                            dispatch('change_forcedVentilationCableDeliver_storeAction', null)
                        }

                        dispatch('get_encoderCableDeliverSelection_storeAction');
                    }
                })
                .catch(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                })
                .then(() => {
                    commit('change_loadCables_storeMutation', false);
                })
        }
    },

    // encoder connection
    async get_encoderConnectionCableInformation_storeAction({ commit, dispatch, rootState, getters }) {

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            encoderCableBlockNumber: getters.encoderCableBlockNumber,
            deliver: getters.encoderCableDeliver,
        }
        await axios({
            method: 'post',
            url: '/api/cables/get_encoderConnectionCableInformation',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_encoderConnectionInformation_storeMutation', response.data.data);
                var hasEncoderConnectionSelection = state.encoderConnectionInformation != null && state.encoderConnectionInformation.hasOwnProperty('details') == true
                if (hasEncoderConnectionSelection) {
                    var selectedEncoderConnection = state.encoderConnectionInformation.details.find(i => (i.selected == true));
                    if (selectedEncoderConnection != null) {
                        dispatch('change_encoderConnectionCableBlockNumber_storeAction', selectedEncoderConnection);
                    }
                    else if (state.encoderCableLengthSelection.details.length > 0) {
                        dispatch('change_encoderConnectionCableBlockNumber_storeAction', state.encoderConnectionInformation.details[0]);
                    }

                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },

    // encoder cable
    async get_encoderCableDeliverSelection_storeAction({ commit, dispatch, rootState }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_encoderCableDeliverSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_encoderCableDeliverSelection_storeMutation', response.data);
                const summaryCables = (rootState.summary.manualHomeSummary != null && rootState.summary.manualHomeSummary.hasOwnProperty('cables')) ? rootState.summary.manualHomeSummary.cables : null;
                let selectedIndex = Array.isArray(state.encoderCableDeliverSelection) ? state.encoderCableDeliverSelection.findIndex(i => (i.selected == true)) : -1;

                if (state.loadCables == true && summaryCables != null && Array.isArray(state.cables_Data.encoderCableDeliverSelection)) {
                    const summaryIndex = state.cables_Data.encoderCableDeliverSelection.findIndex(i => (i != null && i.text != null && i.text.text == summaryCables.encoderCableDeliverOption));
                    if (summaryIndex > -1) {
                        selectedIndex = summaryIndex;
                    }
                }

                const selectedDeliverOption = selectedIndex > -1
                    ? state.encoderCableDeliverSelection[selectedIndex]
                    : (state.encoderCableDeliverSelection.length > 0 ? state.encoderCableDeliverSelection[0] : null);

                if (selectedDeliverOption != null) {
                    dispatch('change_encoderCableDeliver_storeAction', selectedDeliverOption);
                }
                dispatch('get_encoderConnectionCableInformation_storeAction');
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_encoderCablesLengthSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            deliver: getters.encoderCableDeliver,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_encoderCableLengthSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_encoderCableLengthSelection_storeMutation', response.data);
                const list = state.encoderCableLengthSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                const hasManualCables =
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null;

                if (hasManualCables) {
                    const loadedItem = list.find(i => i.value === rootState.summary.manualHomeSummary.cables.forcedVentilationCableLength);
                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                if (selectedItem) {
                    dispatch('change_encoderCableLength_storeAction', selectedItem);
                } else if (list.length > 0) {
                    dispatch('change_encoderCableLength_storeAction', list[0]);
                }

                if (list.length === 0) {
                    const deliverList = state.cables_Data.encoderCable_DeliverOption_Valuelist || [];
                    const deliverItem = deliverList.find(i => i.text.code === 0);

                    if (deliverItem) {
                        dispatch('change_encoderCableDeliver_storeAction', deliverItem);
                    } else {
                        dispatch('change_encoderCableLengthSelection_toDefault_storeAction');
                        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                    }
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_encoderCableTypeOfConnectionOnComponentSideSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.encoderCableLength,
            deliver: getters.encoderCableDeliver,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_encoderCableTypeOfConnectionOnComponentSideSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_encoderCableTypeOfConnectionOnComponentSideSelection_storeMutation', response.data);

                const list = state.encoderCableTypeOfConnectionOnComponentSideSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text == rootState.summary.manualHomeSummary.cables.encoderCableTypeOfConnection);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_encoderCableTypeOfConnectionOnComponentSide_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_encoderCableSpecificationSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.encoderCableLength,
            typeOfConnectionOnComponentSide: getters.encoderCableTypeOfConnectionOnComponentSide,
            deliver: getters.encoderCableDeliver,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_encoderCableSpecificationSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_encoderCableSpecificationSelection_storeMutation', response.data);

                const list = state.encoderCableSpecificationSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text === rootState.summary.manualHomeSummary.cables.encoderCableSpecification);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_encoderCableSpecification_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_encoderCableNumberOfWiresAndCrossSectionSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.encoderCableLength,
            typeOfConnectionOnComponentSide: getters.encoderCableTypeOfConnectionOnComponentSide,
            specification: getters.encoderCableSpecification,
            deliver: getters.encoderCableDeliver,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_encoderCableNumberOfWiresAndCrossSectionSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {

                commit('change_encoderCableNumberOfWiresAndCrossSectionSelection_storeMutation', response.data);

                const list = state.encoderCableNumberOfWiresAndCrossSectionSelection;
                const selectedItem = list.find(i => i.selected === true) || list[0];

                if (selectedItem) {
                    dispatch('change_encoderCableNumberOfWiresAndCrossSection_storeAction', selectedItem);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_encoderCableBlockNumber_storeAction({ commit, dispatch, rootState, getters }) {

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.encoderCableLength,
            typeOfConnectionOnComponentSide: getters.encoderCableTypeOfConnectionOnComponentSide,
            specification: getters.encoderCableSpecification,
            numberOfWires: getters.encoderCableNumberOfWiresAndCrossSection.numberOfWires,
            crossSection: getters.encoderCableNumberOfWiresAndCrossSection.crossSection,
            deliver: getters.encoderCableDeliver,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_encoderCableBlockNumber',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_encoderCableBlockNumberSelection_storeMutation', response.data.data);
                const selectedItem = state.encoderCableBlockNumberSelection.find(i => i.selected === true);
                if (selectedItem) {
                    dispatch('change_encoderCableBlockNumberSelected_storeAction', selectedItem);
                }

                dispatch('get_encoderConnectionCableInformation_storeAction');
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    // motor cable
    async get_motorCablesLengthSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            deliver: getters.motorCableDeliver,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_motorCableLengthSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_motorCableLengthSelection_storeMutation', response.data);

                const list = state.motorCableLengthSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                const hasManualCables =
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null;

                if (hasManualCables) {
                    const loadedItem = list.find(i => i.value === rootState.summary.manualHomeSummary.cables.motorCableLength);
                    if (loadedItem) {
                        selectedItem = loadedItem;
                        commit('changed_userSelectedLengthMotorCable_storeMutation', true);
                    }
                }

                if (state.userSelectedLengthMotorCable === false && state.defaultLengthValue != null) {
                    const defaultItem = list.find(i => i.value === state.defaultLengthValue);
                    if (defaultItem) {
                        selectedItem = defaultItem;
                    }
                }

                if (selectedItem) {
                    dispatch('change_motorCableLength_storeAction', selectedItem);
                } else if (list.length > 0) {
                    dispatch('change_motorCableLength_storeAction', list[0]);
                }

                if (list.length === 0) {
                    const deliverList = state.cables_Data.motorCable_DeliverOption_Valuelist || [];
                    const deliverItem = deliverList.find(i => i.text.code === 0);

                    if (deliverItem) {
                        dispatch('change_motorCableDeliver_storeAction', deliverItem);
                    } else {
                        dispatch('change_motorCableLengthSelection_toDefault_storeAction');
                        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                    }
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_motorCableTypeOfConnectionOnComponentSideSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.motorCableLength,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_motorCableTypeOfConnectionOnComponentSideSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_motorCableTypeOfConnectionOnComponentSideSelection_storeMutation', response.data);

                const list = state.motorCableTypeOfConnectionOnComponentSideSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text == rootState.summary.manualHomeSummary.cables.motorCableTypeOfConnection);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_motorCableTypeOfConnectionOnComponentSide_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_motorCableSpecificationSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.motorCableLength,
            typeOfConnectionOnComponentSide: getters.motorCableTypeOfConnectionOnComponentSide,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_motorCableSpecificationSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_motorCableSpecificationSelection_storeMutation', response.data);

                const list = state.motorCableSpecificationSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text === rootState.summary.manualHomeSummary.cables.motorCableSpecification);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_motorCableSpecification_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_motorCableNumberOfWiresAndCrossSectionSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.motorCableLength,
            typeOfConnectionOnComponentSide: getters.motorCableTypeOfConnectionOnComponentSide,
            specification: getters.motorCableSpecification,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_motorCableNumberOfWiresAndCrossSectionSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_motorCableNumberOfWiresAndCrossSectionSelection_storeMutation', response.data);

                const list = state.motorCableNumberOfWiresAndCrossSectionSelection;
                const selectedItem = list.find(i => i.selected === true) || list[0];

                if (selectedItem) {
                    dispatch('change_motorCableNumberOfWiresAndCrossSection_storeAction', selectedItem);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_motorCableBlockNumber_storeAction({ commit, dispatch, rootState, getters }) {

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.motorCableLength,
            typeOfConnectionOnComponentSide: getters.motorCableTypeOfConnectionOnComponentSide,
            specification: getters.motorCableSpecification,
            numberOfWires: getters.motorCableNumberOfWiresAndCrossSection.numberOfWires,
            crossSection: getters.motorCableNumberOfWiresAndCrossSection.crossSection,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_motorCableBlockNumber',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_motorCableBlockNumberSelection_storeMutation', response.data.data);
                const selectedItem = state.motorCableBlockNumberSelection.find(i => i.selected === true);
                if (selectedItem) {
                    dispatch('change_motorCableBlockNumberSelected_storeAction', selectedItem);
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    // motor protection cable
    async get_motorProtectionCablesLengthSelection_storeAction({ commit, dispatch, rootState }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_motorProtectionCableLengthSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_motorProtectionCableLengthSelection_storeMutation', response.data);

                const list = state.motorProtectionCableLengthSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                const hasManualCables =
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null;

                if (hasManualCables) {
                    const loadedItem = list.find(i => i.value === rootState.summary.manualHomeSummary.cables.motorProtectionCableLength);
                    if (loadedItem) {
                        selectedItem = loadedItem;
                        commit('changed_userSelectedLengthMotorProtectionCable_storeMutation', true);
                    }
                }

                if (state.userSelectedLengthMotorProtectionCable === false && state.defaultLengthValue != null) {
                    const defaultItem = list.find(i => i.value === state.defaultLengthValue);
                    if (defaultItem) {
                        selectedItem = defaultItem;
                    }
                }

                if (selectedItem) {
                    dispatch('change_motorProtectionCableLength_storeAction', selectedItem);
                } else if (list.length > 0) {
                    dispatch('change_motorProtectionCableLength_storeAction', list[0]);
                }

                if (list.length === 0) {
                    const deliverList = state.cables_Data.motorProtectionCable_DeliverOption_Valuelist || [];
                    const deliverItem = deliverList.find(i => i.text.code === 0);

                    if (deliverItem) {
                        dispatch('change_motorProtectionCableDeliver_storeAction', deliverItem);
                    } else {
                        dispatch('change_motorProtectionCableLengthSelection_toDefault_storeAction');
                        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                    }
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_motorProtectionCableTypeOfConnectionOnComponentSideSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.motorProtectionCableLength,
        }
        await axios({
            method: 'post',
            url: '/api/cables/get_motorProtectionCableTypeOfConnectionOnComponentSideSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_motorProtectionCableTypeOfConnectionOnComponentSideSelection_storeMutation', response.data);

                const list = state.motorProtectionCableTypeOfConnectionOnComponentSideSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text == rootState.summary.manualHomeSummary.cables.motorProtectionCableTypeOfConnection);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_motorProtectionCableTypeOfConnectionOnComponentSide_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_motorProtectionCableSpecificationSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.motorProtectionCableLength,
            typeOfConnectionOnComponentSide: getters.motorProtectionCableTypeOfConnectionOnComponentSide,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_motorProtectionCableSpecificationSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_motorProtectionCableSpecificationSelection_storeMutation', response.data);

                const list = state.motorProtectionCableSpecificationSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text === rootState.summary.manualHomeSummary.cables.motorProtectionCableSpecification);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_motorProtectionCableSpecification_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_motorProtectionCableNumberOfWiresAndCrossSectionSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.motorProtectionCableLength,
            typeOfConnectionOnComponentSide: getters.motorProtectionCableTypeOfConnectionOnComponentSide,
            specification: getters.motorProtectionCableSpecification,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_motorProtectionCableNumberOfWiresAndCrossSectionSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_motorProtectionCableNumberOfWiresAndCrossSectionSelection_storeMutation', response.data);
                const list = state.motorProtectionCableNumberOfWiresAndCrossSectionSelection;
                const selectedItem = list.find(i => i.selected === true) || list[0];

                if (selectedItem) {
                    dispatch('change_motorProtectionCableNumberOfWiresAndCrossSection_storeAction', selectedItem);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_motorProtectionCableBlockNumber_storeAction({ commit, dispatch, rootState, getters }) {

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.motorProtectionCableLength,
            typeOfConnectionOnComponentSide: getters.motorProtectionCableTypeOfConnectionOnComponentSide,
            specification: getters.motorProtectionCableSpecification,
            numberOfWires: getters.motorProtectionCableNumberOfWiresAndCrossSection.numberOfWires,
            crossSection: getters.motorProtectionCableNumberOfWiresAndCrossSection.crossSection,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_motorProtectionCableBlockNumber',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_motorProtectionCableBlockNumberSelection_storeMutation', response.data.data);
                const selectedItem = state.motorProtectionCableBlockNumberSelection.find(i => i.selected === true);
                if (selectedItem) {
                    dispatch('change_motorProtectionCableBlockNumberSelected_storeAction', selectedItem);
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    // brake cable
    async get_brakeCablesLengthSelection_storeAction({ commit, dispatch, rootState }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_brakeCableLengthSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_brakeCableLengthSelection_storeMutation', response.data);


                const list = state.brakeCableLengthSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                const hasManualCables =
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null;

                if (hasManualCables) {
                    const loadedItem = list.find(i => i.value === rootState.summary.manualHomeSummary.cables.brakeCableLength);
                    if (loadedItem) {
                        selectedItem = loadedItem;
                        commit('changed_userSelectedLengthBrakeCable_storeMutation', true);
                    }
                }

                if (state.userSelectedLengthBrakeCable === false && state.defaultLengthValue != null) {
                    const defaultItem = list.find(i => i.value === state.defaultLengthValue);
                    if (defaultItem) {
                        selectedItem = defaultItem;
                    }
                }

                if (selectedItem) {
                    dispatch('change_brakeCableLength_storeAction', selectedItem);
                } else if (list.length > 0) {
                    dispatch('change_brakeCableLength_storeAction', list[0]);
                }

                if (list.length === 0) {
                    const deliverList = state.cables_Data.brakeCable_DeliverOption_Valuelist || [];
                    const deliverItem = deliverList.find(i => i.text.code === 0);

                    if (deliverItem) {
                        dispatch('change_brakeCableDeliver_storeAction', deliverItem);
                    } else {
                        dispatch('change_brakeCableLengthSelection_toDefault_storeAction');
                        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                    }
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_brakeCableTypeOfConnectionOnComponentSideSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.brakeCableLength,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_brakeCableTypeOfConnectionOnComponentSideSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_brakeCableTypeOfConnectionOnComponentSideSelection_storeMutation', response.data);

                const list = state.brakeCableTypeOfConnectionOnComponentSideSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text == rootState.summary.manualHomeSummary.cables.brakeCableTypeOfConnection);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_brakeCableTypeOfConnectionOnComponentSide_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_brakeCableSpecificationSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.brakeCableLength,
            typeOfConnectionOnComponentSide: getters.brakeCableTypeOfConnectionOnComponentSide,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_brakeCableSpecificationSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_brakeCableSpecificationSelection_storeMutation', response.data);
                const list = state.brakeCableSpecificationSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text === rootState.summary.manualHomeSummary.cables.brakeCableSpecification);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_brakeCableSpecification_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_brakeCableNumberOfWiresAndCrossSectionSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.brakeCableLength,
            typeOfConnectionOnComponentSide: getters.brakeCableTypeOfConnectionOnComponentSide,
            specification: getters.brakeCableSpecification,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_brakeCableNumberOfWiresAndCrossSectionSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_brakeCableNumberOfWiresAndCrossSectionSelection_storeMutation', response.data);

                const list = state.brakeCableNumberOfWiresAndCrossSectionSelection;
                const selectedItem = list.find(i => i.selected === true) || list[0];

                if (selectedItem) {
                    dispatch('change_brakeCableNumberOfWiresAndCrossSection_storeAction', selectedItem);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_brakeCableBlockNumber_storeAction({ commit, dispatch, rootState, getters }) {

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.brakeCableLength,
            typeOfConnectionOnComponentSide: getters.brakeCableTypeOfConnectionOnComponentSide,
            specification: getters.brakeCableSpecification,
            numberOfWires: getters.brakeCableNumberOfWiresAndCrossSection.numberOfWires,
            crossSection: getters.brakeCableNumberOfWiresAndCrossSection.crossSection,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_brakeCableBlockNumber',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_brakeCableBlockNumberSelection_storeMutation', response.data.data);

                const selectedItem = state.brakeCableBlockNumberSelection.find(i => i.selected === true);
                if (selectedItem) {
                    dispatch('change_brakeCableBlockNumberSelected_storeAction', selectedItem);
                }

                var hasBrakeCable_BA_BL = getters.selectedBrakeCableBlockNumber != null
                    && getters.selectedBrakeCableBlockNumber.hasOwnProperty('typeDesignation')
                    && getters.selectedBrakeCableBlockNumber.typeDesignation.text != null
                    && getters.selectedBrakeCableBlockNumber.typeDesignation.text.substring(0, 5) == "BA/BL"

                commit('change_babl_storeMutation', hasBrakeCable_BA_BL ? true : false);


                if (state.babl == true) {
                    const selectedItem_brakeMonitoringCable = state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist.find(i => (i.text.code == 0));
                    if (selectedItem_brakeMonitoringCable != null) {
                        dispatch('change_brakeMonitoringCableDeliver_storeAction', selectedItem_brakeMonitoringCable.text.code);
                    }
                    else {
                        commit('change_brakeMonitoringCableDeliverSelected_storeMutation', null);
                        dispatch('change_brakeMonitoringCableDeliverDetails_toDefault_storeAction');
                    }
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    // brake monitoring cable
    async get_brakeMonitoringCablesLengthSelection_storeAction({ commit, dispatch, rootState }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_brakeMonitoringCableLengthSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_brakeMonitoringCableLengthSelection_storeMutation', response.data);

                const list = state.brakeMonitoringCableLengthSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                const hasManualCables =
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null;

                if (hasManualCables) {
                    const loadedItem = list.find(i => i.value === rootState.summary.manualHomeSummary.cables.brakeMonitoringCableLength);
                    if (loadedItem) {
                        selectedItem = loadedItem;
                        commit('changed_userSelectedLengthBrakeMonitoringCable_storeMutation', true);
                    }
                }

                if (state.userSelectedLengthBrakeMonitoringCable === false && state.defaultLengthValue != null) {
                    const defaultItem = list.find(i => i.value === state.defaultLengthValue);
                    if (defaultItem) {
                        selectedItem = defaultItem;
                    }
                }

                if (selectedItem) {
                    dispatch('change_brakeMonitoringCableLength_storeAction', selectedItem);
                } else if (list.length > 0) {
                    dispatch('change_brakeMonitoringCableLength_storeAction', list[0]);
                }


                if (list.length === 0) {
                    const deliverList = state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist || [];
                    const deliverItem = deliverList.find(i => i.text.code === 0);

                    if (deliverItem) {
                        dispatch('change_brakeMonitoringCableDeliver_storeAction', deliverItem);
                    } else {
                        dispatch('change_brakeMonitoringCableLengthSelection_toDefault_storeAction');
                        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                    }
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.brakeMonitoringCableLength,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection_storeMutation', response.data);

                const list = state.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text == rootState.summary.manualHomeSummary.cables.brakeMonitoringCableTypeOfConnection);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_brakeMonitoringCableTypeOfConnectionOnComponentSide_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_brakeMonitoringCableSpecificationSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.brakeMonitoringCableLength,
            typeOfConnectionOnComponentSide: getters.brakeMonitoringCableTypeOfConnectionOnComponentSide,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_brakeMonitoringCableSpecificationSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_brakeMonitoringCableSpecificationSelection_storeMutation', response.data);

                const list = state.brakeMonitoringCableSpecificationSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text === rootState.summary.manualHomeSummary.cables.brakeMonitoringCableSpecification);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_brakeMonitoringCableSpecification_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }


            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.brakeMonitoringCableLength,
            typeOfConnectionOnComponentSide: getters.brakeMonitoringCableTypeOfConnectionOnComponentSide,
            specification: getters.brakeMonitoringCableSpecification,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_storeMutation', response.data);

                const list = state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection;
                const selectedItem = list.find(i => i.selected === true) || list[0];

                if (selectedItem) {
                    dispatch('change_brakeMonitoringCableNumberOfWiresAndCrossSection_storeAction', selectedItem);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_brakeMonitoringCableBlockNumber_storeAction({ commit, dispatch, rootState, getters }) {

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.brakeMonitoringCableLength,
            typeOfConnectionOnComponentSide: getters.brakeMonitoringCableTypeOfConnectionOnComponentSide,
            specification: getters.brakeMonitoringCableSpecification,
            numberOfWires: getters.brakeMonitoringCableNumberOfWiresAndCrossSection.numberOfWires,
            crossSection: getters.brakeMonitoringCableNumberOfWiresAndCrossSection.crossSection,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_brakeMonitoringCableBlockNumber',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_brakeMonitoringCableBlockNumberSelection_storeMutation', response.data.data);

                const selectedItem = state.brakeMonitoringCableBlockNumberSelection.find(i => i.selected === true);
                if (selectedItem) {
                    dispatch('change_brakeMonitoringCableBlockNumberSelected_storeAction', selectedItem);
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    // forced ventiltion cable
    async get_forcedVentilationCablesLengthSelection_storeAction({ commit, dispatch, rootState }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_forcedVentilationCableLengthSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_forcedVentilationCableLengthSelection_storeMutation', response.data);
                const list = state.forcedVentilationCableLengthSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                const hasManualCables =
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null;

                if (hasManualCables) {
                    const loadedItem = list.find(i => i.value === rootState.summary.manualHomeSummary.cables.forcedVentilationCableLength);
                    if (loadedItem) {
                        selectedItem = loadedItem;
                        commit('changed_userSelectedLengthForcedVentilationCable_storeMutation', true);
                    }
                }

                if (state.userSelectedLengthForcedVentilationCable === false && state.defaultLengthValue != null) {
                    const defaultItem = list.find(i => i.value === state.defaultLengthValue);
                    if (defaultItem) {
                        selectedItem = defaultItem;
                    }
                }

                if (selectedItem) {
                    dispatch('change_forcedVentilationCableLength_storeAction', selectedItem);
                } else if (list.length > 0) {
                    dispatch('change_forcedVentilationCableLength_storeAction', list[0]);
                }

                if (list.length === 0) {
                    const deliverList = state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist || [];
                    const deliverItem = deliverList.find(i => i.text.code === 0);

                    if (deliverItem) {
                        dispatch('change_forcedVentilationCableDeliver_storeAction', deliverItem);
                    } else {
                        dispatch('change_forcedVentilationCableLengthSelection_toDefault_storeAction');
                        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                    }
                }


            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_forcedVentilationCableTypeOfConnectionOnComponentSideSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.forcedVentilationCableLength,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_forcedVentilationCableTypeOfConnectionOnComponentSideSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_forcedVentilationCableTypeOfConnectionOnComponentSideSelection_storeMutation', response.data);
                const list = state.forcedVentilationCableTypeOfConnectionOnComponentSideSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text == rootState.summary.manualHomeSummary.cables.forcedVentilationCableTypeOfConnection);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_forcedVentilationCableTypeOfConnectionOnComponentSide_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_forcedVentilationCableSpecificationSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.forcedVentilationCableLength,
            typeOfConnectionOnComponentSide: getters.forcedVentilationCableTypeOfConnectionOnComponentSide,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_forcedVentilationCableSpecificationSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_forcedVentilationCableSpecificationSelection_storeMutation', response.data);

                const list = state.forcedVentilationCableSpecificationSelection || [];
                let selectedItem = list.find(i => i.selected === true);

                if (
                    state.loadCables === true &&
                    rootState.summary.manualHomeSummary != null &&
                    rootState.summary.manualHomeSummary.hasOwnProperty('cables') &&
                    rootState.summary.manualHomeSummary.cables != null
                ) {
                    const loadedItem = list.find(i => i.text.text === rootState.summary.manualHomeSummary.cables.forcedVentilationCableSpecification);

                    if (loadedItem) {
                        selectedItem = loadedItem;
                    }
                }

                const item = selectedItem || list[0];

                if (item) {
                    dispatch('change_forcedVentilationCableSpecification_storeAction', item);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_storeAction({ commit, dispatch, rootState, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.forcedVentilationCableLength,
            typeOfConnectionOnComponentSide: getters.forcedVentilationTypeOfConnectionOnComponentSide,
            specification: getters.forcedVentilationCableSpecification,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_forcedVentilationCableNumberOfWiresAndCrossSectionSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_storeMutation', response.data);

                const list = state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection;
                const selectedItem = list.find(i => i.selected === true) || list[0];

                if (selectedItem) {
                    dispatch('change_forcedVentilationCableNumberOfWiresAndCrossSection_storeAction', selectedItem);
                } else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_forcedVentilationCableBlockNumber_storeAction({ commit, dispatch, rootState, getters }) {

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            length: getters.forcedVentilationCableLength,
            typeOfConnectionOnComponentSide: getters.forcedVentilationCableTypeOfConnectionOnComponentSide,
            specification: getters.forcedVentilationCableSpecification,
            numberOfWires: getters.forcedVentilationCableNumberOfWiresAndCrossSection.numberOfWires,
            crossSection: getters.forcedVentilationCableNumberOfWiresAndCrossSection.crossSection,
        }

        await axios({
            method: 'post',
            url: '/api/cables/get_forcedVentilationCableBlockNumber',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_forcedVentilationCableBlockNumberSelection_storeMutation', response.data.data);

                const selectedItem = state.forcedVentilationCableBlockNumberSelection.find(i => i.selected === true);
                if (selectedItem) {
                    dispatch('change_forcedVentilationCableBlockNumberSelected_storeAction', selectedItem);
                }

            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    change_cablesSelection_toDefault_storeAction({ commit, dispatch }) {
        dispatch('change_motorCableLengthSelection_toDefault_storeAction');
        dispatch('change_motorProtectionCableLengthSelection_toDefault_storeAction');
        dispatch('change_brakeCableLengthSelection_toDefault_storeAction');
        dispatch('change_brakeMonitoringCableLengthSelection_toDefault_storeAction');
        dispatch('change_forcedVentilationCableLengthSelection_toDefault_storeAction');
        commit('change_encoderConnectionInformation_storeMutation', {});
    },

    change_encoderCableLengthSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_encoderCableLengthSelection_storeMutation', []);
        dispatch('change_encoderCableLength_storeAction', null);

        dispatch('change_encoderCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_encoderCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_encoderCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_encoderCableBlockNumberSelection_storeMutation', []);
    },
    change_motorCableLengthSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_motorCableLengthSelection_storeMutation', []);
        dispatch('change_motorCableLength_storeAction', null);

        dispatch('change_motorCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_motorCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_motorCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_motorCableBlockNumberSelection_storeMutation', []);
    },
    change_motorProtectionCableLengthSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_motorProtectionCableLengthSelection_storeMutation', []);
        dispatch('change_motorProtectionCableLength_storeAction', null);

        dispatch('change_motorProtectionCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_motorProtectionCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_motorProtectionCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_motorProtectionCableBlockNumberSelection_storeMutation', []);
    },
    change_brakeCableLengthSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_brakeCableLengthSelection_storeMutation', []);
        dispatch('change_brakeCableLength_storeAction', null);

        dispatch('change_brakeCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_brakeCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_brakeCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_brakeCableBlockNumberSelection_storeMutation', []);
        commit('change_babl_storeMutation', false);
    },
    change_brakeMonitoringCableLengthSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_brakeMonitoringCableLengthSelection_storeMutation', []);
        dispatch('change_brakeMonitoringCableLength_storeAction', null);

        dispatch('change_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_brakeMonitoringCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_brakeMonitoringCableBlockNumberSelection_storeMutation', []);
    },
    change_forcedVentilationCableLengthSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_forcedVentilationCableLengthSelection_storeMutation', []);
        dispatch('change_forcedVentilationCableLength_storeAction', null);

        dispatch('change_forcedVentilationCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_forcedVentilationCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_forcedVentilationCableBlockNumberSelection_storeMutation', []);
    },

    change_encoderCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_encoderCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        dispatch('change_encoderCableTypeOfConnectionOnComponentSide_storeAction', null);

        dispatch('change_encoderCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_encoderCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_encoderCableBlockNumberSelection_storeMutation', []);
    },
    change_motorCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_motorCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        dispatch('change_motorCableTypeOfConnectionOnComponentSide_storeAction', null);

        dispatch('change_motorCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_motorCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_motorCableBlockNumberSelection_storeMutation', []);
    },
    change_motorProtectionCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_motorProtectionCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        dispatch('change_motorProtectionCableTypeOfConnectionOnComponentSide_storeAction', null);

        dispatch('change_motorProtectionCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_motorProtectionCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_motorProtectionCableBlockNumberSelection_storeMutation', []);
    },
    change_brakeCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_brakeCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        dispatch('change_brakeCableTypeOfConnectionOnComponentSide_storeAction', null);

        dispatch('change_brakeCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_brakeCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_brakeCableBlockNumberSelection_storeMutation', []);
        commit('change_babl_storeMutation', false);
    },
    change_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        dispatch('change_brakeMonitoringCableTypeOfConnectionOnComponentSide_storeAction', null);

        dispatch('change_brakeMonitoringCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_brakeMonitoringCableBlockNumberSelection_storeMutation', []);
    },
    change_forcedVentilationCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_forcedVentilationCableTypeOfConnectionOnComponentSideSelection_storeMutation', []);
        dispatch('change_forcedVentilationCableTypeOfConnectionOnComponentSide_storeAction', null);

        dispatch('change_forcedVentilationCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_forcedVentilationCableBlockNumberSelection_storeMutation', []);
    },

    change_encoderCableSpecificationSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_encoderCableSpecificationSelection_storeMutation', []);
        dispatch('change_encoderCableSpecification_storeAction', null);

        dispatch('change_encoderCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_encoderCableBlockNumberSelection_storeMutation', []);
    },
    change_motorCableSpecificationSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_motorCableSpecificationSelection_storeMutation', []);
        dispatch('change_motorCableSpecification_storeAction', null);

        dispatch('change_motorCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_motorCableBlockNumberSelection_storeMutation', []);
    },
    change_motorProtectionCableSpecificationSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_motorProtectionCableSpecificationSelection_storeMutation', []);
        dispatch('change_motorProtectionCableSpecification_storeAction', null);

        dispatch('change_motorProtectionCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_motorProtectionCableBlockNumberSelection_storeMutation', []);
    },
    change_brakeCableSpecificationSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_brakeCableSpecificationSelection_storeMutation', []);
        dispatch('change_brakeCableSpecification_storeAction', null);

        dispatch('change_brakeCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_brakeCableBlockNumberSelection_storeMutation', []);
        commit('change_babl_storeMutation', false);
    },
    change_brakeMonitoringCableSpecificationSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_brakeMonitoringCableSpecificationSelection_storeMutation', []);
        dispatch('change_brakeMonitoringCableSpecification_storeAction', null);

        dispatch('change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_brakeMonitoringCableBlockNumberSelection_storeMutation', []);
    },
    change_forcedVentilationCableSpecificationSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_forcedVentilationCableSpecificationSelection_storeMutation', []);
        dispatch('change_forcedVentilationCableSpecification_storeAction', null);

        dispatch('change_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_forcedVentilationCableBlockNumberSelection_storeMutation', []);
    },

    change_encoderCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_encoderCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        dispatch('change_encoderCableNumberOfWiresAndCrossSection_storeAction', null);

        commit('change_encoderCableBlockNumberSelection_storeMutation', []);
    },
    change_motorCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_motorCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        dispatch('change_motorCableNumberOfWiresAndCrossSection_storeAction', null);

        commit('change_motorCableBlockNumberSelection_storeMutation', []);
    },
    change_motorProtectionCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_motorProtectionCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        dispatch('change_motorProtectionCableNumberOfWiresAndCrossSection_storeAction', null);

        commit('change_motorProtectionCableBlockNumberSelection_storeMutation', []);
    },
    change_brakeCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_brakeCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        dispatch('change_brakeCableNumberOfWiresAndCrossSection_storeAction', null);

        commit('change_brakeCableBlockNumberSelection_storeMutation', []);
        commit('change_babl_storeMutation', false);
    },
    change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        dispatch('change_brakeMonitoringCableNumberOfWiresAndCrossSection_storeAction', null);

        commit('change_brakeMonitoringCableBlockNumberSelection_storeMutation', []);
    },
    change_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction({ commit, dispatch }) {
        commit('change_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_storeMutation', []);
        dispatch('change_forcedVentilationCableNumberOfWiresAndCrossSection_storeAction', null);

        commit('change_forcedVentilationCableBlockNumberSelection_storeMutation', []);
    },

    change_encoderCableDeliverDetails_toDefault_storeAction({ commit, dispatch }) {
        dispatch('change_encoderCableLengthSelection_toDefault_storeAction');
        dispatch('change_encoderCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_encoderCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_encoderCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_encoderCableBlockNumberSelection_storeMutation', []);
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    },
    change_motorCableDeliverDetails_toDefault_storeAction({ commit, dispatch }) {
        dispatch('change_motorCableLengthSelection_toDefault_storeAction');
        dispatch('change_motorCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_motorCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_motorCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_motorCableBlockNumberSelection_storeMutation', []);
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    },
    change_motorProtectionCableDeliverDetails_toDefault_storeAction({ commit, dispatch }) {
        dispatch('change_motorProtectionCableLengthSelection_toDefault_storeAction');
        dispatch('change_motorProtectionCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_motorProtectionCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_motorProtectionCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_motorProtectionCableBlockNumberSelection_storeMutation', []);
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    },
    change_brakeCableDeliverDetails_toDefault_storeAction({ commit, dispatch }) {
        dispatch('change_brakeCableLengthSelection_toDefault_storeAction');
        dispatch('change_brakeCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_brakeCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_brakeCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_brakeCableBlockNumberSelection_storeMutation', []);
        commit('change_babl_storeMutation', false);
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    },
    change_brakeMonitoringCableDeliverDetails_toDefault_storeAction({ commit, dispatch }) {
        dispatch('change_brakeMonitoringCableLengthSelection_toDefault_storeAction');
        dispatch('change_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_brakeMonitoringCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_brakeMonitoringCableBlockNumberSelection_storeMutation', []);
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    },
    change_forcedVentilationCableDeliverDetails_toDefault_storeAction({ commit, dispatch }) {
        dispatch('change_forcedVentilationCableLengthSelection_toDefault_storeAction');
        dispatch('change_forcedVentilationCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction');
        dispatch('change_forcedVentilationCableSpecificationSelection_toDefault_storeAction');
        dispatch('change_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction');
        commit('change_forcedVentilationCableBlockNumberSelection_storeMutation', []);
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    },

    change_encoderConnectionCableBlockNumber_storeAction({ commit, dispatch }, value) {
        commit('change_encoderConnectionCableSelected_storeMutation', value == null ? null : value.blockNumber);
    },

    change_encoderCableDeliver_storeAction({ commit, dispatch }, value) {
        commit('change_encoderCableDeliverSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.encoderCableDeliverSelection || [];
        const selectedItem = list.find(i => i.selected === true);

        if (selectedItem && selectedItem.showDetails === true) {
            dispatch('get_encoderCablesLengthSelection_storeAction');
        } else {
            dispatch('change_encoderCableDeliverDetails_toDefault_storeAction');
        }

        dispatch('get_encoderConnectionCableInformation_storeAction');
    },
    change_motorCableDeliver_storeAction({ commit, dispatch }, value) {
        commit('change_motorCableDeliverSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.cables_Data.motorCable_DeliverOption_Valuelist || [];
        const selectedItem = list.find(i => i.selected === true);
        if (selectedItem && selectedItem.showDetails === true) {
            dispatch('get_motorCablesLengthSelection_storeAction');
        } else {
            dispatch('change_motorCableDeliverDetails_toDefault_storeAction');
        }
    },
    change_motorProtectionCableDeliver_storeAction({ commit, dispatch }, value) {
        commit('change_motorProtectionCableDeliverSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.cables_Data.motorProtectionCable_DeliverOption_Valuelist || [];
        const selectedItem = list.find(i => i.selected === true);

        if (selectedItem && selectedItem.showDetails === true) {
            dispatch('get_motorProtectionCablesLengthSelection_storeAction');
        } else {
            dispatch('change_motorProtectionCableDeliverDetails_toDefault_storeAction');
        }
    },
    change_brakeCableDeliver_storeAction({ commit, dispatch }, value) {
        commit('change_brakeCableDeliverSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.cables_Data.brakeCable_DeliverOption_Valuelist || [];
        const selectedItem = list.find(i => i.selected === true);

        if (selectedItem && selectedItem.showDetails === true) {
            dispatch('get_brakeCablesLengthSelection_storeAction');
        } else {
            dispatch('change_brakeCableDeliverDetails_toDefault_storeAction');
        }
    },
    change_brakeMonitoringCableDeliver_storeAction({ commit, dispatch }, value) {
        if (value == null) {
            commit('change_brakeMonitoringCableDeliverSelected_storeMutation', null);
        }
        else {
            if (state.babl == false) {
                commit('change_brakeMonitoringCableDeliverSelected_storeMutation', value.text.text);

                const list = state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist || [];
                const selectedItem = list.find(i => i.selected === true);

                if (selectedItem && selectedItem.showDetails === true) {
                    dispatch('get_brakeMonitoringCablesLengthSelection_storeAction');
                } else {
                    dispatch('change_brakeMonitoringCableDeliverDetails_toDefault_storeAction');
                }
            }
            else {
                const list2 = state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist;
                const item = list2.find(i => i.text.code === 0);

                commit('change_brakeMonitoringCableDeliverSelected_storeMutation', item ? item.text.text : null);

                if (!item) {
                    dispatch('change_brakeMonitoringCableDeliverDetails_toDefault_storeAction');
                }
            }
        }
    },
    change_forcedVentilationCableDeliver_storeAction({ commit, dispatch }, value) {
        commit('change_forcedVentilationCableDeliverSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist || [];
        const selectedItem = list.find(i => i.selected === true);

        if (selectedItem && selectedItem.showDetails === true) {
            dispatch('get_forcedVentilationCablesLengthSelection_storeAction');
        } else {
            dispatch('change_forcedVentilationCableDeliverDetails_toDefault_storeAction');
        }
    },

    change_encoderCableLength_storeAction({ commit, dispatch, getters }, value) {
        dispatch('change_encoderCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction')
        commit('change_encoderCableLengthSelected_storeMutation', value == null ? null : value.value);
        const list = state.encoderCableLengthSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_encoderCableTypeOfConnectionOnComponentSideSelection_storeAction');
            commit('changed_defaultLengthValue_storeMutation', getters.encoderCableLength)
            dispatch('check_cableLengthDefaultValues_EncoderCableSelection', getters.encoderCableLength);
        }
    },
    change_motorCableLength_storeAction({ commit, dispatch }, value) {
        dispatch('change_motorCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction')
        commit('change_motorCableLengthSelected_storeMutation', value == null ? null : value.value);

        const list = state.motorCableLengthSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_motorCableTypeOfConnectionOnComponentSideSelection_storeAction')
        }
    },
    change_motorProtectionCableLength_storeAction({ commit, dispatch }, value) {
        dispatch('change_motorProtectionCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction')
        commit('change_motorProtectionCableLengthSelected_storeMutation', value == null ? null : value.value);

        const list = state.motorProtectionCableLengthSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_motorProtectionCableTypeOfConnectionOnComponentSideSelection_storeAction')
        }
    },
    change_brakeCableLength_storeAction({ commit, dispatch }, value) {
        dispatch('change_brakeCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction')
        commit('change_brakeCableLengthSelected_storeMutation', value == null ? null : value.value);

        const list = state.brakeCableLengthSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_brakeCableTypeOfConnectionOnComponentSideSelection_storeAction')
        }
    },
    change_brakeMonitoringCableLength_storeAction({ commit, dispatch }, value) {
        dispatch('change_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction')
        commit('change_brakeMonitoringCableLengthSelected_storeMutation', value == null ? null : value.value);

        const list = state.brakeMonitoringCableLengthSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection_storeAction')
        }
    },
    change_forcedVentilationCableLength_storeAction({ commit, dispatch }, value) {
        dispatch('change_forcedVentilationCableTypeOfConnectionOnComponentSideSelection_toDefault_storeAction')
        commit('change_forcedVentilationCableLengthSelected_storeMutation', value == null ? null : value.value);

        const list = state.forcedVentilationCableLengthSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_forcedVentilationCableTypeOfConnectionOnComponentSideSelection_storeAction')
        }
    },

    change_encoderCableTypeOfConnectionOnComponentSide_storeAction({ commit, dispatch }, value) {
        dispatch('change_encoderCableSpecificationSelection_toDefault_storeAction')
        commit('change_encoderCableTypeOfConnectionOnComponentSideSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.encoderCableTypeOfConnectionOnComponentSideSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_encoderCableSpecificationSelection_storeAction')
        }
    },
    change_motorCableTypeOfConnectionOnComponentSide_storeAction({ commit, dispatch }, value) {
        dispatch('change_motorCableSpecificationSelection_toDefault_storeAction')
        commit('change_motorCableTypeOfConnectionOnComponentSideSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.motorCableTypeOfConnectionOnComponentSideSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_motorCableSpecificationSelection_storeAction')
        }
    },
    change_motorProtectionCableTypeOfConnectionOnComponentSide_storeAction({ commit, dispatch }, value) {
        dispatch('change_motorProtectionCableSpecificationSelection_toDefault_storeAction')
        commit('change_motorProtectionCableTypeOfConnectionOnComponentSideSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.motorProtectionCableTypeOfConnectionOnComponentSideSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_motorProtectionCableSpecificationSelection_storeAction')
        }
    },
    change_brakeCableTypeOfConnectionOnComponentSide_storeAction({ commit, dispatch }, value) {
        dispatch('change_brakeCableSpecificationSelection_toDefault_storeAction')
        commit('change_brakeCableTypeOfConnectionOnComponentSideSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.brakeCableTypeOfConnectionOnComponentSideSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_brakeCableSpecificationSelection_storeAction')
        }
    },
    change_brakeMonitoringCableTypeOfConnectionOnComponentSide_storeAction({ commit, dispatch }, value) {
        dispatch('change_brakeMonitoringCableSpecificationSelection_toDefault_storeAction')
        commit('change_brakeMonitoringCableTypeOfConnectionOnComponentSideSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_brakeMonitoringCableSpecificationSelection_storeAction')
        }
    },
    change_forcedVentilationCableTypeOfConnectionOnComponentSide_storeAction({ commit, dispatch }, value) {
        dispatch('change_forcedVentilationCableSpecificationSelection_toDefault_storeAction')
        commit('change_forcedVentilationCableTypeOfConnectionOnComponentSideSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.forcedVentilationCableTypeOfConnectionOnComponentSideSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_forcedVentilationCableSpecificationSelection_storeAction')
        }
    },

    change_encoderCableSpecification_storeAction({ commit, dispatch }, value) {
        dispatch('change_encoderCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction')
        commit('change_encoderCableSpecificationSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.encoderCableSpecificationSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_encoderCableNumberOfWiresAndCrossSectionSelection_storeAction')
        }
    },
    change_motorCableSpecification_storeAction({ commit, dispatch }, value) {
        dispatch('change_motorCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction')
        commit('change_motorCableSpecificationSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.motorCableSpecificationSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_motorCableNumberOfWiresAndCrossSectionSelection_storeAction')
        }
    },
    change_motorProtectionCableSpecification_storeAction({ commit, dispatch }, value) {
        dispatch('change_motorProtectionCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction')
        commit('change_motorProtectionCableSpecificationSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.motorProtectionCableSpecificationSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_motorProtectionCableNumberOfWiresAndCrossSectionSelection_storeAction')
        }
    },
    change_brakeCableSpecification_storeAction({ commit, dispatch }, value) {
        dispatch('change_brakeCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction')
        commit('change_brakeCableSpecificationSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.brakeCableSpecificationSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_brakeCableNumberOfWiresAndCrossSectionSelection_storeAction')
        }
    },
    change_brakeMonitoringCableSpecification_storeAction({ commit, dispatch }, value) {
        dispatch('change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction')
        commit('change_brakeMonitoringCableSpecificationSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.brakeMonitoringCableSpecificationSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_storeAction')
        }
    },
    change_forcedVentilationCableSpecification_storeAction({ commit, dispatch }, value) {
        dispatch('change_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_toDefault_storeAction')
        commit('change_forcedVentilationCableSpecificationSelected_storeMutation', value == null ? null : value.text.text);

        const list = state.forcedVentilationCableSpecificationSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_storeAction')
        }
    },

    change_encoderCableNumberOfWiresAndCrossSection_storeAction({ commit, dispatch }, value) {
        commit('change_encoderCableBlockNumberSelection_storeMutation', []);
        commit('change_encoderCableNumberOfWiresAndCrossSectionSelected_storeMutation', value);

        const list = state.encoderCableNumberOfWiresAndCrossSectionSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_encoderCableBlockNumber_storeAction')
        }
    },
    change_motorCableNumberOfWiresAndCrossSection_storeAction({ commit, dispatch }, value) {
        commit('change_motorCableBlockNumberSelection_storeMutation', []);
        commit('change_motorCableNumberOfWiresAndCrossSectionSelected_storeMutation', value);

        const list = state.motorCableNumberOfWiresAndCrossSectionSelection
        if (state.motorCableNumberOfWiresAndCrossSectionSelection.some(i => i.selected)) {
            dispatch('get_motorCableBlockNumber_storeAction')
        }
    },
    change_motorProtectionCableNumberOfWiresAndCrossSection_storeAction({ commit, dispatch }, value) {
        commit('change_motorProtectionCableBlockNumberSelection_storeMutation', []);
        commit('change_motorProtectionCableNumberOfWiresAndCrossSectionSelected_storeMutation', value);

        const list = state.motorProtectionCableNumberOfWiresAndCrossSectionSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_motorProtectionCableBlockNumber_storeAction')
        }
    },
    change_brakeCableNumberOfWiresAndCrossSection_storeAction({ commit, dispatch }, value) {
        commit('change_brakeCableBlockNumberSelection_storeMutation', []);
        commit('change_babl_storeMutation', false);
        commit('change_brakeCableNumberOfWiresAndCrossSectionSelected_storeMutation', value);

        const list = state.brakeCableNumberOfWiresAndCrossSectionSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_brakeCableBlockNumber_storeAction')
        }
    },
    change_brakeMonitoringCableNumberOfWiresAndCrossSection_storeAction({ commit, dispatch }, value) {
        commit('change_brakeMonitoringCableBlockNumberSelection_storeMutation', []);
        commit('change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelected_storeMutation', value);

        const list = state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_brakeMonitoringCableBlockNumber_storeAction')
        }
    },
    change_forcedVentilationCableNumberOfWiresAndCrossSection_storeAction({ commit, dispatch }, value) {
        commit('change_forcedVentilationCableBlockNumberSelection_storeMutation', []);
        commit('change_forcedVentilationCableNumberOfWiresAndCrossSectionSelected_storeMutation', value);

        const list = state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection
        if (Array.isArray(list) && list.some(i => i.selected)) {
            dispatch('get_forcedVentilationCableBlockNumber_storeAction');
        }
    },

    change_encoderCableBlockNumberSelected_storeAction({ commit, dispatch }, value) {
        commit('change_encoderCableBlockNumberSelected_storeMutation', value);
    },
    change_motorCableBlockNumberSelected_storeAction({ commit, dispatch }, value) {
        commit('change_motorCableBlockNumberSelected_storeMutation', value);
    },
    change_motorProtectionCableBlockNumberSelected_storeAction({ commit, dispatch }, value) {
        commit('change_motorProtectionCableBlockNumberSelected_storeMutation', value);
    },
    change_brakeCableBlockNumberSelected_storeAction({ commit, dispatch }, value) {
        commit('change_brakeCableBlockNumberSelected_storeMutation', value);
    },
    change_brakeMonitoringCableBlockNumberSelected_storeAction({ commit, dispatch }, value) {
        commit('change_brakeMonitoringCableBlockNumberSelected_storeMutation', value);
    },
    change_forcedVentilationCableBlockNumberSelected_storeAction({ commit, dispatch }, value) {
        commit('change_forcedVentilationCableBlockNumberSelected_storeMutation', value);
    },

    check_cableLengthDefaultValues_EncoderCableSelection({ commit, dispatch, rootState }, value) {
        if (rootState.inputsManual.motorCablesManualData != null && rootState.inputsManual.motorCablesManualData.hasOwnProperty('details')) {
        }
        else {
            if (value != null) {
                if (state.userSelectedLengthMotorCable == false) {
                    const firstIndex_whichMeetConditions_motorCable = state.motorCableLengthSelection.findIndex(i => (i.value == value));
                    if (firstIndex_whichMeetConditions_motorCable > -1) {
                        dispatch('change_motorCableLength_storeAction', state.motorCableLengthSelection[firstIndex_whichMeetConditions_motorCable])
                    }
                }
                if (state.userSelectedLengthMotorProtectionCable == false) {
                    const firstIndex_whichMeetConditions_motorProtectionCable = state.motorProtectionCableLengthSelection.findIndex(i => (i.value == value));
                    if (firstIndex_whichMeetConditions_motorProtectionCable > -1) {
                        dispatch('change_motorProtectionCableLength_storeAction', state.motorProtectionCableLengthSelection[firstIndex_whichMeetConditions_motorProtectionCable])
                    }
                }
                if (state.userSelectedLengthBrakeCable == false) {
                    const firstIndex_whichMeetConditions_brakeCable = state.brakeCableLengthSelection.findIndex(i => (i.value == value));
                    if (firstIndex_whichMeetConditions_brakeCable > -1) {
                        dispatch('change_brakeCableLength_storeAction', state.brakeCableLengthSelection[firstIndex_whichMeetConditions_brakeCable])
                    }
                }
                if (state.userSelectedLengthBrakeMonitoringCable == false) {
                    const firstIndex_whichMeetConditions_brakeMonitoringCable = state.brakeMonitoringCableLengthSelection.findIndex(i => (i.value == value));
                    if (firstIndex_whichMeetConditions_brakeMonitoringCable > -1) {
                        dispatch('change_brakeMonitoringCableLength_storeAction', state.brakeMonitoringCableLengthSelection[firstIndex_whichMeetConditions_brakeMonitoringCable])
                    }
                }
                if (state.userSelectedLengthForcedVentilationCable == false) {
                    const firstIndex_whichMeetConditions_forcedVentilationCable = state.forcedVentilationCableLengthSelection.findIndex(i => (i.value == value));
                    if (firstIndex_whichMeetConditions_forcedVentilationCable > -1) {
                        dispatch('change_forcedVentilationCableLength_storeAction', state.forcedVentilationCableLengthSelection[firstIndex_whichMeetConditions_forcedVentilationCable])
                    }
                }
            }
        }
    },

    checkIf_cablesManual_areValid_storeAction({ rootState, dispatch, getters }) {
        var numberOf_inputs_whichAreInvalid = 0;
        if (state.cables_Data.encoderCable_Necessary == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.encoderCableDeliver == null || (getters.encoderCableDeliver != 0 && getters.encoderCableBlockNumber == null)) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.cables_Data.encoderCable_Necessary == true) {
            if (state.encoderConnectionInformation == null || state.encoderConnectionInformation.hasOwnProperty('details') == false) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
            else {
                const firstIndex_whichMeetConditions = state.encoderConnectionInformation.details.findIndex(i => (i.selected == true));
                if (firstIndex_whichMeetConditions == -1) {
                    numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
                }
                else if (state.encoderConnectionInformation.details[firstIndex_whichMeetConditions].blockNumber == null) {
                    numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
                }
            }
        }
        if (state.cables_Data.motorCable_Necessary == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.motorCableDeliver == null || (getters.motorCableDeliver != 0 && getters.motorCableBlockNumber == null)) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.cables_Data.motorProtectionCable_Necessary == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.motorProtectionCableDeliver == null || (getters.motorProtectionCableDeliver != 0 && getters.motorProtectionCableBlockNumber == null)) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.cables_Data.brakeCable_Necessary == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.brakeCableDeliver == null || (getters.brakeCableDeliver != 0 && getters.brakeCableBlockNumber == null)) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.cables_Data.brakeMonitoringCable_Necessary == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.brakeMonitoringCableDeliver == null || (getters.brakeMonitoringCableDeliver != 0 && getters.brakeMonitoringCableBlockNumber == null)) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.cables_Data.forcedVentilationCable_Necessary == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.forcedVentilationCableDeliver == null || (getters.forcedVentilationCableDeliver != 0 && getters.forcedVentilationCableBlockNumber == null)) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (numberOf_inputs_whichAreInvalid > 0) {
            this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 1446 }, { textKey: 1449 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
        }
        else if (numberOf_inputs_whichAreInvalid == 0) {
            dispatch('insertOrUpdate_cables_storeAction');
        }

    },

    async insertOrUpdate_cables_storeAction({ dispatch, rootState, getters }) {
        const cablesManual = {
            motorCableNecessary: state.cables_Data.motorCable_Necessary,
            motorCableSelected: getters.motorCableBlockNumber != null ? true : false,
            tNLML: getters.motorCableBlockNumber,
            sMLMAN: getters.motorCableLength,
            lLML: getters.motorCableDeliver,
            sMLP01: getters.motorCableTypeOfConnectionOnComponentSide,
            sMLSPE: getters.motorCableSpecification,
            motorCableTypeDesignation: getters.motorCableTypeDesignation,
            motorCableNumberOfWires: getters.motorCableNumberOfWires,
            sMLA1: getters.motorCableCrossSection,
            motorProtectionCableNecessary: state.cables_Data.motorProtectionCable_Necessary,
            motorProtectionCableSelected: getters.motorProtectionCableBlockNumber != null ? true : false,
            tNLMSL: getters.motorProtectionCableBlockNumber,
            sMSMaN: getters.motorProtectionCableLength,
            lLMS: getters.motorProtectionCableDeliver,
            sMSP01: getters.motorProtectionCableTypeOfConnectionOnComponentSide,
            sMSSPE: getters.motorProtectionCableSpecification,
            motorProtectionCableTypeDesignation: getters.motorProtectionCableTypeDesignation,
            motorProtectionCableNumberOfWires: getters.motorProtectionCableNumberOfWires,
            sMSA1: getters.motorProtectionCableCrossSection,
            encoderCableNecessary: state.cables_Data.encoderCable_Necessary,
            encoderCableSelected: getters.encoderCableBlockNumber != null ? true : false,
            tNLGL: getters.encoderCableBlockNumber,
            sGLMaN: getters.encoderCableLength,
            lLGL: getters.encoderCableDeliver,
            sGLP01: getters.encoderCableTypeOfConnectionOnComponentSide,
            sGLSPE: getters.encoderCableSpecification,
            encoderCableTypeDesignation: getters.encoderCableTypeDesignation,
            encoderCableNumberOfWires: getters.encoderCableNumberOfWires,
            encoderCableCrossSection: getters.encoderCableCrossSection,
            encoderConnectionSelected: getters.encoderConnectionCableBlockNumber != null ? true : false,
            tNLGA: getters.encoderConnectionCableBlockNumber,
            encoderConnectionLength: getters.encoderConnectionCableLength,
            encoderConnectionTypeOfConnection: getters.encoderConnectionCableTypeOfConnection,
            brakeCableNecessary: state.cables_Data.brakeCable_Necessary,
            brakeCableSelected: getters.brakeCableBlockNumber != null ? true : false,
            tNLBA: getters.brakeCableBlockNumber,
            sBAMaN: getters.brakeCableLength,
            lLBA: getters.brakeCableDeliver,
            sBAP01: getters.brakeCableTypeOfConnectionOnComponentSide,
            brakeCableSpecification: getters.brakeCableSpecification,
            brakeCableTypeDesignation: getters.brakeCableTypeDesignation,
            brakeCableNumberOfWires: getters.brakeCableNumberOfWires,
            brakeCableCrossSection: getters.brakeCableCrossSection,
            brakeMonitoringCableNecessary: state.cables_Data.brakeMonitoringCable_Necessary,
            brakeMonitoringCableSelected: getters.brakeMonitoringCableBlockNumber != null ? true : false,
            tNLBL: getters.brakeMonitoringCableBlockNumber,
            sBLMaN: getters.brakeMonitoringCableLength,
            lLBL: getters.brakeMonitoringCableDeliver,
            sBLP01: getters.brakeMonitoringCableTypeOfConnectionOnComponentSide,
            brakeMonitoringCableSpecification: getters.brakeMonitoringCableSpecification,
            brakeMonitoringCableTypeDesignation: getters.brakeMonitoringCableTypeDesignation,
            brakeMonitoringCableNumberOfWires: getters.brakeMonitoringCableNumberOfWires,
            brakeMonitoringCableCrossSection: getters.brakeMonitoringCableCrossSection,
            forcedVentilationNecessary: state.cables_Data.forcedVentilationCable_Necessary,
            forcedVentilationCableSelected: getters.forcedVentilationCableBlockNumber != null ? true : false,
            tNFLei: getters.forcedVentilationCableBlockNumber,
            sFLMaN: getters.forcedVentilationCableLength,
            lLFBL: getters.forcedVentilationCableDeliver,
            forcedVentilationCableP01: getters.forcedVentilationCableTypeOfConnectionOnComponentSide,
            forcedVentilationCableSpecification: getters.forcedVentilationCableSpecification,
            forcedVentilationCableTypeDesignation: getters.forcedVentilationCableTypeDesignation,
            forcedVentilationCableNumberOfWires: getters.forcedVentilationCableNumberOfWires,
            forcedVentilationCableCrossSection: getters.forcedVentilationCableCrossSection
        }

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            cablesManual: cablesManual,
        }

        await axios({
            method: 'post',
            url: '/api/configurations/insertOrUpdate_cablesManual',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);

                if (response.data.status.statusCode.substring(0, 1) == '2') {
                    router.push({ params: { slug: 'suppliesMotorManual' } })
                }
                else {
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })

            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },
}



const mutations = {

    // cable data
    change_loadCables_storeMutation(state, payload) {
        state.loadCables = payload;
    },
    change_cables_Data_storeMutation(state, payload) {
        if (payload == null) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
        state.cables_Data = payload;
    },

    change_encoderCableDeliverSelection_storeMutation(state, payload) {
        if (payload == null) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
        state.encoderCableDeliverSelection = payload;
    },

    change_encoderCableDeliverSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.encoderCableDeliverSelection.length; i++) {
            state.encoderCableDeliverSelection[i].selected = false;

            if (state.encoderCableDeliverSelection[i].text.text == payload) {
                state.encoderCableDeliverSelection[i].selected = true;
            }
        }
    },
    change_motorCableDeliverSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.cables_Data.motorCable_DeliverOption_Valuelist.length; i++) {
            state.cables_Data.motorCable_DeliverOption_Valuelist[i].selected = false;

            if (state.cables_Data.motorCable_DeliverOption_Valuelist[i].text.text == payload) {
                state.cables_Data.motorCable_DeliverOption_Valuelist[i].selected = true;
            }
        }
    },
    change_motorProtectionCableDeliverSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.cables_Data.motorProtectionCable_DeliverOption_Valuelist.length; i++) {
            state.cables_Data.motorProtectionCable_DeliverOption_Valuelist[i].selected = false;

            if (state.cables_Data.motorProtectionCable_DeliverOption_Valuelist[i].text.text == payload) {
                state.cables_Data.motorProtectionCable_DeliverOption_Valuelist[i].selected = true;
            }
        }
    },
    change_brakeCableDeliverSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.cables_Data.brakeCable_DeliverOption_Valuelist.length; i++) {
            state.cables_Data.brakeCable_DeliverOption_Valuelist[i].selected = false;

            if (state.cables_Data.brakeCable_DeliverOption_Valuelist[i].text.text == payload) {
                state.cables_Data.brakeCable_DeliverOption_Valuelist[i].selected = true;
            }
        }
    },
    change_brakeMonitoringCableDeliverSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist.length; i++) {
            state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist[i].selected = false;

            if (state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist[i].text.text == payload) {
                state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist[i].selected = true;
            }
        }
    },
    change_forcedVentilationCableDeliverSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist.length; i++) {
            state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist[i].selected = false;

            if (state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist[i].text.text == payload) {
                state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist[i].selected = true;
            }
        }
    },

    // encoderConnection
    change_encoderConnectionInformation_storeMutation(state, payload) {
        state.encoderConnectionInformation = payload;
    },
    change_encoderConnectionCableSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.encoderConnectionInformation.details.length; i++) {
            state.encoderConnectionInformation.details[i].selected = false;

            if (state.encoderConnectionInformation.details[i].blockNumber == payload) {
                state.encoderConnectionInformation.details[i].selected = true;
            }
        }
    },
    // encoder cable 
    change_encoderCableLengthSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.encoderCableLengthSelection = payload;
    },
    change_encoderCableLengthSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.encoderCableLengthSelection.length; i++) {
            state.encoderCableLengthSelection[i].selected = false;

            if (state.encoderCableLengthSelection[i].value == payload) {
                state.encoderCableLengthSelection[i].selected = true;
            }
        }
    },

    // motor cable 
    change_motorCableLengthSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.motorCableLengthSelection = payload;
    },
    change_motorCableLengthSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorCableLengthSelection.length; i++) {
            state.motorCableLengthSelection[i].selected = false;

            if (state.motorCableLengthSelection[i].value == payload) {
                state.motorCableLengthSelection[i].selected = true;
            }
        }
    },

    // motor protection cable 
    change_motorProtectionCableLengthSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.motorProtectionCableLengthSelection = payload;
    },
    change_motorProtectionCableLengthSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorProtectionCableLengthSelection.length; i++) {
            state.motorProtectionCableLengthSelection[i].selected = false;

            if (state.motorProtectionCableLengthSelection[i].value == payload) {
                state.motorProtectionCableLengthSelection[i].selected = true;
            }
        }
    },

    // brake cable 
    change_brakeCableLengthSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.brakeCableLengthSelection = payload;
    },
    change_brakeCableLengthSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeCableLengthSelection.length; i++) {
            state.brakeCableLengthSelection[i].selected = false;

            if (state.brakeCableLengthSelection[i].value == payload) {
                state.brakeCableLengthSelection[i].selected = true;
            }
        }
    },

    // brake monitoring cable 
    change_brakeMonitoringCableLengthSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.brakeMonitoringCableLengthSelection = payload;
    },
    change_brakeMonitoringCableLengthSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeMonitoringCableLengthSelection.length; i++) {
            state.brakeMonitoringCableLengthSelection[i].selected = false;

            if (state.brakeMonitoringCableLengthSelection[i].value == payload) {
                state.brakeMonitoringCableLengthSelection[i].selected = true;
            }
        }
    },

    // forced ventiltion cable
    change_forcedVentilationCableLengthSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.forcedVentilationCableLengthSelection = payload;
    },
    change_forcedVentilationCableLengthSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.forcedVentilationCableLengthSelection.length; i++) {
            state.forcedVentilationCableLengthSelection[i].selected = false;

            if (state.forcedVentilationCableLengthSelection[i].value == payload) {
                state.forcedVentilationCableLengthSelection[i].selected = true;
            }
        }
    },

    // encoder cable
    change_encoderCableTypeOfConnectionOnComponentSideSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.encoderCableTypeOfConnectionOnComponentSideSelection = payload;
    },
    change_encoderCableTypeOfConnectionOnComponentSideSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.encoderCableTypeOfConnectionOnComponentSideSelection.length; i++) {
            state.encoderCableTypeOfConnectionOnComponentSideSelection[i].selected = false;

            if (state.encoderCableTypeOfConnectionOnComponentSideSelection[i].text.text == payload) {
                state.encoderCableTypeOfConnectionOnComponentSideSelection[i].selected = true;
            }
        }
    },

    // motor cable
    change_motorCableTypeOfConnectionOnComponentSideSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.motorCableTypeOfConnectionOnComponentSideSelection = payload;
    },
    change_motorCableTypeOfConnectionOnComponentSideSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorCableTypeOfConnectionOnComponentSideSelection.length; i++) {
            state.motorCableTypeOfConnectionOnComponentSideSelection[i].selected = false;
            if (state.motorCableTypeOfConnectionOnComponentSideSelection[i].text.text == payload) {
                state.motorCableTypeOfConnectionOnComponentSideSelection[i].selected = true;
            }
        }
    },

    // motor protection cable
    change_motorProtectionCableTypeOfConnectionOnComponentSideSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.motorProtectionCableTypeOfConnectionOnComponentSideSelection = payload;
    },
    change_motorProtectionCableTypeOfConnectionOnComponentSideSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorProtectionCableTypeOfConnectionOnComponentSideSelection.length; i++) {
            state.motorProtectionCableTypeOfConnectionOnComponentSideSelection[i].selected = false;

            if (state.motorProtectionCableTypeOfConnectionOnComponentSideSelection[i].text.text == payload) {
                state.motorProtectionCableTypeOfConnectionOnComponentSideSelection[i].selected = true;
            }
        }
    },

    // brake cable
    change_brakeCableTypeOfConnectionOnComponentSideSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.brakeCableTypeOfConnectionOnComponentSideSelection = payload;
    },
    change_brakeCableTypeOfConnectionOnComponentSideSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeCableTypeOfConnectionOnComponentSideSelection.length; i++) {
            state.brakeCableTypeOfConnectionOnComponentSideSelection[i].selected = false;

            if (state.brakeCableTypeOfConnectionOnComponentSideSelection[i].text.text == payload) {
                state.brakeCableTypeOfConnectionOnComponentSideSelection[i].selected = true;
            }
        }
    },

    // brake monitoring cable
    change_brakeMonitoringCableTypeOfConnectionOnComponentSideSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection = payload;
    },
    change_brakeMonitoringCableTypeOfConnectionOnComponentSideSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection.length; i++) {
            state.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection[i].selected = false;

            if (state.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection[i].text.text == payload) {
                state.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection[i].selected = true;
            }
        }
    },

    // forced ventiltion cable
    change_forcedVentilationCableTypeOfConnectionOnComponentSideSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.forcedVentilationCableTypeOfConnectionOnComponentSideSelection = payload;
    },
    change_forcedVentilationCableTypeOfConnectionOnComponentSideSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.forcedVentilationCableTypeOfConnectionOnComponentSideSelection.length; i++) {
            state.forcedVentilationCableTypeOfConnectionOnComponentSideSelection[i].selected = false;

            if (state.forcedVentilationCableTypeOfConnectionOnComponentSideSelection[i].text.text == payload) {
                state.forcedVentilationCableTypeOfConnectionOnComponentSideSelection[i].selected = true;
            }
        }
    },

    // encoder cable
    change_encoderCableSpecificationSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.encoderCableSpecificationSelection = payload;
    },
    change_encoderCableSpecificationSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.encoderCableSpecificationSelection.length; i++) {
            state.encoderCableSpecificationSelection[i].selected = false;

            if (state.encoderCableSpecificationSelection[i].text.text == payload) {
                state.encoderCableSpecificationSelection[i].selected = true;
            }
        }
    },

    // motor cable
    change_motorCableSpecificationSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.motorCableSpecificationSelection = payload;
    },
    change_motorCableSpecificationSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorCableSpecificationSelection.length; i++) {
            state.motorCableSpecificationSelection[i].selected = false;
            if (state.motorCableSpecificationSelection[i].text.text == payload) {
                state.motorCableSpecificationSelection[i].selected = true;
            }
        }
    },

    // motor protection cable
    change_motorProtectionCableSpecificationSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.motorProtectionCableSpecificationSelection = payload;
    },
    change_motorProtectionCableSpecificationSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorProtectionCableSpecificationSelection.length; i++) {
            state.motorProtectionCableSpecificationSelection[i].selected = false;

            if (state.motorProtectionCableSpecificationSelection[i].text.text == payload) {
                state.motorProtectionCableSpecificationSelection[i].selected = true;
            }
        }
    },

    // brake cable
    change_brakeCableSpecificationSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.brakeCableSpecificationSelection = payload;
    },
    change_brakeCableSpecificationSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeCableSpecificationSelection.length; i++) {
            state.brakeCableSpecificationSelection[i].selected = false;

            if (state.brakeCableSpecificationSelection[i].text.text == payload) {
                state.brakeCableSpecificationSelection[i].selected = true;
            }
        }
    },

    // brake monitoring cable
    change_brakeMonitoringCableSpecificationSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.brakeMonitoringCableSpecificationSelection = payload;
    },
    change_brakeMonitoringCableSpecificationSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeMonitoringCableSpecificationSelection.length; i++) {
            state.brakeMonitoringCableSpecificationSelection[i].selected = false;

            if (state.brakeMonitoringCableSpecificationSelection[i].text.text == payload) {
                state.brakeMonitoringCableSpecificationSelection[i].selected = true;
            }
        }
    },

    // forced ventiltion
    change_forcedVentilationCableSpecificationSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.forcedVentilationCableSpecificationSelection = payload;
    },
    change_forcedVentilationCableSpecificationSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.forcedVentilationCableSpecificationSelection.length; i++) {
            state.forcedVentilationCableSpecificationSelection[i].selected = false;

            if (state.forcedVentilationCableSpecificationSelection[i].text.text == payload) {
                state.forcedVentilationCableSpecificationSelection[i].selected = true;
            }
        }
    },

    // encoder cable
    change_encoderCableNumberOfWiresAndCrossSectionSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.encoderCableNumberOfWiresAndCrossSectionSelection = payload;
    },
    change_encoderCableNumberOfWiresAndCrossSectionSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.encoderCableNumberOfWiresAndCrossSectionSelection.length; i++) {
            state.encoderCableNumberOfWiresAndCrossSectionSelection[i].selected = false;

            if (state.encoderCableNumberOfWiresAndCrossSectionSelection[i].numberOfWires == payload.numberOfWires && state.encoderCableNumberOfWiresAndCrossSectionSelection[i].crossSection == payload.crossSection) {
                state.encoderCableNumberOfWiresAndCrossSectionSelection[i].selected = true;
            }
        }
    },

    // motor cable
    change_motorCableNumberOfWiresAndCrossSectionSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.motorCableNumberOfWiresAndCrossSectionSelection = payload;
    },
    change_motorCableNumberOfWiresAndCrossSectionSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorCableNumberOfWiresAndCrossSectionSelection.length; i++) {
            state.motorCableNumberOfWiresAndCrossSectionSelection[i].selected = false;
            if (state.motorCableNumberOfWiresAndCrossSectionSelection[i].numberOfWires == payload.numberOfWires && state.motorCableNumberOfWiresAndCrossSectionSelection[i].crossSection == payload.crossSection) {
                state.motorCableNumberOfWiresAndCrossSectionSelection[i].selected = true;
            }
        }
    },

    // motor protection cable
    change_motorProtectionCableNumberOfWiresAndCrossSectionSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.motorProtectionCableNumberOfWiresAndCrossSectionSelection = payload;
    },
    change_motorProtectionCableNumberOfWiresAndCrossSectionSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorProtectionCableNumberOfWiresAndCrossSectionSelection.length; i++) {
            state.motorProtectionCableNumberOfWiresAndCrossSectionSelection[i].selected = false;

            if (state.motorProtectionCableNumberOfWiresAndCrossSectionSelection[i].numberOfWires == payload.numberOfWires && state.motorProtectionCableNumberOfWiresAndCrossSectionSelection[i].crossSection == payload.crossSection) {
                state.motorProtectionCableNumberOfWiresAndCrossSectionSelection[i].selected = true;
            }
        }
    },

    // brake cable
    change_brakeCableNumberOfWiresAndCrossSectionSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.brakeCableNumberOfWiresAndCrossSectionSelection = payload;
    },
    change_brakeCableNumberOfWiresAndCrossSectionSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeCableNumberOfWiresAndCrossSectionSelection.length; i++) {
            state.brakeCableNumberOfWiresAndCrossSectionSelection[i].selected = false;

            if (state.brakeCableNumberOfWiresAndCrossSectionSelection[i].numberOfWires == payload.numberOfWires && state.brakeCableNumberOfWiresAndCrossSectionSelection[i].crossSection == payload.crossSection) {
                state.brakeCableNumberOfWiresAndCrossSectionSelection[i].selected = true;
            }
        }
    },

    // brake monitoring cable
    change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection = payload;
    },
    change_brakeMonitoringCableNumberOfWiresAndCrossSectionSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection.length; i++) {
            state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection[i].selected = false;

            if (state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection[i].numberOfWires == payload.numberOfWires && state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection[i].crossSection == payload.crossSection) {
                state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection[i].selected = true;
            }
        }
    },

    // forced ventiltion cable
    change_forcedVentilationCableNumberOfWiresAndCrossSectionSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection = payload;
    },
    change_forcedVentilationCableNumberOfWiresAndCrossSectionSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection.length; i++) {
            state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection[i].selected = false;

            if (state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection[i].numberOfWires == payload.numberOfWires && state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection[i].crossSection == payload.crossSection) {
                state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection[i].selected = true;
            }
        }
    },

    // encoder cable
    change_encoderCableBlockNumberSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.encoderCableBlockNumberSelection = payload;
    },
    change_encoderCableBlockNumberSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.encoderCableBlockNumberSelection.length; i++) {
            state.encoderCableBlockNumberSelection[i].selected = false;

            if (state.encoderCableBlockNumberSelection[i].blockNumber == payload.blockNumber) {
                state.encoderCableBlockNumberSelection[i].selected = true;
            }
        }
    },
    // motor cable
    change_motorCableBlockNumberSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.motorCableBlockNumberSelection = payload;
    },
    change_motorCableBlockNumberSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorCableBlockNumberSelection.length; i++) {
            state.motorCableBlockNumberSelection[i].selected = false;
            if (state.motorCableBlockNumberSelection[i].blockNumber == payload.blockNumber) {
                state.motorCableBlockNumberSelection[i].selected = true;
            }
        }
    },
    // motor protection cable
    change_motorProtectionCableBlockNumberSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.motorProtectionCableBlockNumberSelection = payload;
    },
    change_motorProtectionCableBlockNumberSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorProtectionCableBlockNumberSelection.length; i++) {
            state.motorProtectionCableBlockNumberSelection[i].selected = false;

            if (state.motorProtectionCableBlockNumberSelection[i].blockNumber == payload.blockNumber) {
                state.motorProtectionCableBlockNumberSelection[i].selected = true;
            }
        }
    },
    // brake cable
    change_brakeCableBlockNumberSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.brakeCableBlockNumberSelection = payload;
    },
    change_brakeCableBlockNumberSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeCableBlockNumberSelection.length; i++) {
            state.brakeCableBlockNumberSelection[i].selected = false;

            if (state.brakeCableBlockNumberSelection[i].blockNumber == payload.blockNumber) {
                state.brakeCableBlockNumberSelection[i].selected = true;
            }
        }
    },
    // brake monitoring cable
    change_brakeMonitoringCableBlockNumberSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.brakeMonitoringCableBlockNumberSelection = payload;
    },
    change_brakeMonitoringCableBlockNumberSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.brakeMonitoringCableBlockNumberSelection.length; i++) {
            state.brakeMonitoringCableBlockNumberSelection[i].selected = false;

            if (state.brakeMonitoringCableBlockNumberSelection[i].blockNumber == payload.blockNumber) {
                state.brakeMonitoringCableBlockNumberSelection[i].selected = true;
            }
        }
    },
    // forced ventiltion cable
    change_forcedVentilationCableBlockNumberSelection_storeMutation(state, payload) {
        if (payload == null || payload.length == 0) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

        state.forcedVentilationCableBlockNumberSelection = payload;
    },
    change_forcedVentilationCableBlockNumberSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.forcedVentilationCableBlockNumberSelection.length; i++) {
            state.forcedVentilationCableBlockNumberSelection[i].selected = false;

            if (state.forcedVentilationCableBlockNumberSelection[i].blockNumber == payload.blockNumber) {
                state.forcedVentilationCableBlockNumberSelection[i].selected = true;
            }
        }
    },

    change_babl_storeMutation(state, payload) {
        state.babl = payload;
    },

    changed_defaultLengthValue_storeMutation(state, payload) {
        state.defaultLengthValue = payload;
    },
    changed_userSelectedLengthEncoderCable_storeMutation(state, payload) {
        state.userSelectedLengthEncoderCable = payload;
    },
    changed_userSelectedLengthMotorCable_storeMutation(state, payload) {
        state.userSelectedLengthMotorCable = payload;
    },
    changed_userSelectedLengthMotorProtectionCable_storeMutation(state, payload) {
        state.userSelectedLengthMotorProtectionCable = payload;
    },
    changed_userSelectedLengthBrakeCable_storeMutation(state, payload) {
        state.userSelectedLengthBrakeCable = payload;
    },
    changed_userSelectedLengthBrakeMonitoringCable_storeMutation(state, payload) {
        state.userSelectedLengthBrakeMonitoringCable = payload;
    },
    changed_userSelectedLengthForcedVentilationCable_storeMutation(state, payload) {
        state.userSelectedLengthForcedVentilationCable = payload;
    },
}

const getters = {
    selectedEncoderConnectionCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return state.encoderConnectionInformation != null && state.encoderConnectionInformation.hasOwnProperty('details') && Array.isArray(state.encoderConnectionInformation.details) ? state.encoderConnectionInformation.details.find(i => i.selected === true) || null : null;
    },
    encoderConnectionCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return getters.selectedEncoderConnectionCableBlockNumber != null ? getters.selectedEncoderConnectionCableBlockNumber.blockNumber : null;
    },
    encoderConnectionCableLength: (state, getters, rootState, rootGetters) => {
        return getters.selectedEncoderConnectionCableBlockNumber != null ? getters.selectedEncoderConnectionCableBlockNumber.length : null;
    },
    encoderConnectionCableTypeOfConnection: (state, getters, rootState, rootGetters) => {
        return getters.selectedEncoderConnectionCableBlockNumber != null ? getters.selectedEncoderConnectionCableBlockNumber.typeOfConnection : null;
    },


    selectedEncoderCableLength: (state, getters, rootState, rootGetters) => {
        return state.encoderCableLengthSelection != null && Array.isArray(state.encoderCableLengthSelection) ? state.encoderCableLengthSelection.find(i => i.selected === true) || null : null;
    },
    selectedEncoderCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return state.encoderCableTypeOfConnectionOnComponentSideSelection != null && Array.isArray(state.encoderCableTypeOfConnectionOnComponentSideSelection) ? state.encoderCableTypeOfConnectionOnComponentSideSelection.find(i => i.selected === true) || null : null;
    },
    selectedEncoderCableSpecification: (state, getters, rootState, rootGetters) => {
        return state.encoderCableSpecificationSelection != null && Array.isArray(state.encoderCableSpecificationSelection) ? state.encoderCableSpecificationSelection.find(i => i.selected === true) || null : null;
    },
    selectedEncoderCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return state.encoderCableBlockNumberSelection != null && Array.isArray(state.encoderCableBlockNumberSelection) ? state.encoderCableBlockNumberSelection.find(i => i.selected === true) || null : null;
    },
    selectedEncoderCableDeliver: (state, getters, rootState, rootGetters) => {
        return state.encoderCableDeliverSelection != null && Array.isArray(state.encoderCableDeliverSelection) ? state.encoderCableDeliverSelection.find(i => i.selected === true) || null : null;
    },
    encoderCableLength: (state, getters, rootState, rootGetters) => {
        return getters.selectedEncoderCableLength != null ? getters.selectedEncoderCableLength.value : null;
    },
    encoderCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return getters.selectedEncoderCableTypeOfConnectionOnComponentSide != null && getters.selectedEncoderCableTypeOfConnectionOnComponentSide.text != null ? getters.selectedEncoderCableTypeOfConnectionOnComponentSide.text.text : null;
    },
    encoderCableSpecification: (state, getters, rootState, rootGetters) => {
        return getters.selectedEncoderCableSpecification != null && getters.selectedEncoderCableSpecification.text != null ? getters.selectedEncoderCableSpecification.text.text : null;
    },
    encoderCableNumberOfWiresAndCrossSection: (state, getters, rootState, rootGetters) => {
        return state.encoderCableNumberOfWiresAndCrossSectionSelection != null && Array.isArray(state.encoderCableNumberOfWiresAndCrossSectionSelection) ? state.encoderCableNumberOfWiresAndCrossSectionSelection.find(i => i.selected === true) || null : null;
    },
    encoderCableNumberOfWires: (state, getters, rootState, rootGetters) => {
        return getters.encoderCableNumberOfWiresAndCrossSection != null ? getters.encoderCableNumberOfWiresAndCrossSection.numberOfWires : null;
    },
    encoderCableCrossSection: (state, getters, rootState, rootGetters) => {
        return getters.encoderCableNumberOfWiresAndCrossSection != null ? getters.encoderCableNumberOfWiresAndCrossSection.crossSection : null;
    },
    encoderCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return getters.selectedEncoderCableBlockNumber != null ? getters.selectedEncoderCableBlockNumber.blockNumber : null;
    },
    encoderCableTypeDesignation: (state, getters, rootState, rootGetters) => {
        return getters.selectedEncoderCableBlockNumber != null ? getters.selectedEncoderCableBlockNumber.typeDesignation.text : null;
    },
    encoderCableDeliver: (state, getters, rootState, rootGetters) => {
        return getters.selectedEncoderCableDeliver != null && getters.selectedEncoderCableDeliver.text != null ? getters.selectedEncoderCableDeliver.text.code : null;
    },


    selectedMotorCableLength: (state, getters, rootState, rootGetters) => {
        return state.motorCableLengthSelection != null && Array.isArray(state.motorCableLengthSelection) ? state.motorCableLengthSelection.find(i => i.selected === true) || null : null;
    },
    selectedMotorCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return state.motorCableTypeOfConnectionOnComponentSideSelection != null && Array.isArray(state.motorCableTypeOfConnectionOnComponentSideSelection) ? state.motorCableTypeOfConnectionOnComponentSideSelection.find(i => i.selected === true) || null : null;
    },
    selectedMotorCableSpecification: (state, getters, rootState, rootGetters) => {
        return state.motorCableSpecificationSelection != null && Array.isArray(state.motorCableSpecificationSelection) ? state.motorCableSpecificationSelection.find(i => i.selected === true) || null : null;
    },
    selectedMotorCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return state.motorCableBlockNumberSelection != null && Array.isArray(state.motorCableBlockNumberSelection) ? state.motorCableBlockNumberSelection.find(i => i.selected === true) || null : null;
    },
    selectedMotorCableDeliver: (state, getters, rootState, rootGetters) => {
        return state.cables_Data != null && state.cables_Data.hasOwnProperty('motorCable_DeliverOption_Valuelist') && Array.isArray(state.cables_Data.motorCable_DeliverOption_Valuelist) ? state.cables_Data.motorCable_DeliverOption_Valuelist.find(i => i.selected === true) || null : null;
    },
    motorCableLength: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorCableLength != null ? getters.selectedMotorCableLength.value : null;
    },
    motorCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorCableTypeOfConnectionOnComponentSide != null && getters.selectedMotorCableTypeOfConnectionOnComponentSide.text != null ? getters.selectedMotorCableTypeOfConnectionOnComponentSide.text.text : null;
    },
    motorCableSpecification: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorCableSpecification != null && getters.selectedMotorCableSpecification.text != null ? getters.selectedMotorCableSpecification.text.text : null;
    },
    motorCableNumberOfWiresAndCrossSection: (state, getters, rootState, rootGetters) => {
        return state.motorCableNumberOfWiresAndCrossSectionSelection != null && Array.isArray(state.motorCableNumberOfWiresAndCrossSectionSelection) ? state.motorCableNumberOfWiresAndCrossSectionSelection.find(i => i.selected === true) || null : null;
    },
    motorCableNumberOfWires: (state, getters, rootState, rootGetters) => {
        return getters.motorCableNumberOfWiresAndCrossSection != null ? getters.motorCableNumberOfWiresAndCrossSection.numberOfWires : null;
    },
    motorCableCrossSection: (state, getters, rootState, rootGetters) => {
        return getters.motorCableNumberOfWiresAndCrossSection != null ? getters.motorCableNumberOfWiresAndCrossSection.crossSection : null;
    },
    motorCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorCableBlockNumber != null ? getters.selectedMotorCableBlockNumber.blockNumber : null;
    },
    motorCableTypeDesignation: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorCableBlockNumber != null ? getters.selectedMotorCableBlockNumber.typeDesignation.text : null;
    },
    motorCableDeliver: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorCableDeliver != null && getters.selectedMotorCableDeliver.text != null ? getters.selectedMotorCableDeliver.text.code : null;
    },


    selectedMotorProtectionCableLength: (state, getters, rootState, rootGetters) => {
        return state.motorProtectionCableLengthSelection != null && Array.isArray(state.motorProtectionCableLengthSelection) ? state.motorProtectionCableLengthSelection.find(i => i.selected === true) || null : null;
    },
    selectedMotorProtectionCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return state.motorProtectionCableTypeOfConnectionOnComponentSideSelection != null && Array.isArray(state.motorProtectionCableTypeOfConnectionOnComponentSideSelection) ? state.motorProtectionCableTypeOfConnectionOnComponentSideSelection.find(i => i.selected === true) || null : null;
    },
    selectedMotorProtectionCableSpecification: (state, getters, rootState, rootGetters) => {
        return state.motorProtectionCableSpecificationSelection != null && Array.isArray(state.motorProtectionCableSpecificationSelection) ? state.motorProtectionCableSpecificationSelection.find(i => i.selected === true) || null : null;
    },
    selectedMotorProtectionCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return state.motorProtectionCableBlockNumberSelection != null && Array.isArray(state.motorProtectionCableBlockNumberSelection) ? state.motorProtectionCableBlockNumberSelection.find(i => i.selected === true) || null : null;
    },
    selectedMotorProtectionCableDeliver: (state, getters, rootState, rootGetters) => {
        return state.cables_Data != null && state.cables_Data.hasOwnProperty('motorProtectionCable_DeliverOption_Valuelist') && Array.isArray(state.cables_Data.motorProtectionCable_DeliverOption_Valuelist) ? state.cables_Data.motorProtectionCable_DeliverOption_Valuelist.find(i => i.selected === true) || null : null;
    },
    motorProtectionCableLength: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorProtectionCableLength != null ? getters.selectedMotorProtectionCableLength.value : null;
    },
    motorProtectionCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorProtectionCableTypeOfConnectionOnComponentSide != null && getters.selectedMotorProtectionCableTypeOfConnectionOnComponentSide.text != null ? getters.selectedMotorProtectionCableTypeOfConnectionOnComponentSide.text.text : null;
    },
    motorProtectionCableSpecification: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorProtectionCableSpecification != null && getters.selectedMotorProtectionCableSpecification.text != null ? getters.selectedMotorProtectionCableSpecification.text.text : null;
    },
    motorProtectionCableNumberOfWiresAndCrossSection: (state, getters, rootState, rootGetters) => {
        return state.motorProtectionCableNumberOfWiresAndCrossSectionSelection != null && Array.isArray(state.motorProtectionCableNumberOfWiresAndCrossSectionSelection) ? state.motorProtectionCableNumberOfWiresAndCrossSectionSelection.find(i => i.selected === true) || null : null;
    },
    motorProtectionCableNumberOfWires: (state, getters, rootState, rootGetters) => {
        return getters.motorProtectionCableNumberOfWiresAndCrossSection != null ? getters.motorProtectionCableNumberOfWiresAndCrossSection.numberOfWires : null;
    },
    motorProtectionCableCrossSection: (state, getters, rootState, rootGetters) => {
        return getters.motorProtectionCableNumberOfWiresAndCrossSection != null ? getters.motorProtectionCableNumberOfWiresAndCrossSection.crossSection : null;
    },
    motorProtectionCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorProtectionCableBlockNumber != null ? getters.selectedMotorProtectionCableBlockNumber.blockNumber : null;
    },
    motorProtectionCableTypeDesignation: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorProtectionCableBlockNumber != null ? getters.selectedMotorProtectionCableBlockNumber.typeDesignation.text : null;
    },
    motorProtectionCableDeliver: (state, getters, rootState, rootGetters) => {
        return getters.selectedMotorProtectionCableDeliver != null && getters.selectedMotorProtectionCableDeliver.text != null ? getters.selectedMotorProtectionCableDeliver.text.code : null;
    },


    selectedBrakeCableLength: (state, getters, rootState, rootGetters) => {
        return state.brakeCableLengthSelection != null && Array.isArray(state.brakeCableLengthSelection) ? state.brakeCableLengthSelection.find(i => i.selected === true) || null : null;
    },
    selectedBrakeCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return state.brakeCableTypeOfConnectionOnComponentSideSelection != null && Array.isArray(state.brakeCableTypeOfConnectionOnComponentSideSelection) ? state.brakeCableTypeOfConnectionOnComponentSideSelection.find(i => i.selected === true) || null : null;
    },
    selectedBrakeCableSpecification: (state, getters, rootState, rootGetters) => {
        return state.brakeCableSpecificationSelection != null && Array.isArray(state.brakeCableSpecificationSelection) ? state.brakeCableSpecificationSelection.find(i => i.selected === true) || null : null;
    },
    selectedBrakeCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return state.brakeCableBlockNumberSelection != null && Array.isArray(state.brakeCableBlockNumberSelection) ? state.brakeCableBlockNumberSelection.find(i => i.selected === true) || null : null;
    },
    selectedBrakeCableDeliver: (state, getters, rootState, rootGetters) => {
        return state.cables_Data != null && state.cables_Data.hasOwnProperty('brakeCable_DeliverOption_Valuelist') && Array.isArray(state.cables_Data.brakeCable_DeliverOption_Valuelist) ? state.cables_Data.brakeCable_DeliverOption_Valuelist.find(i => i.selected === true) || null : null;
    },
    brakeCableLength: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeCableLength != null ? getters.selectedBrakeCableLength.value : null;
    },
    brakeCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeCableTypeOfConnectionOnComponentSide != null && getters.selectedBrakeCableTypeOfConnectionOnComponentSide.text != null ? getters.selectedBrakeCableTypeOfConnectionOnComponentSide.text.text : null;
    },
    brakeCableSpecification: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeCableSpecification != null && getters.selectedBrakeCableSpecification.text != null ? getters.selectedBrakeCableSpecification.text.text : null;
    },
    brakeCableNumberOfWiresAndCrossSection: (state, getters, rootState, rootGetters) => {
        return state.brakeCableNumberOfWiresAndCrossSectionSelection != null && Array.isArray(state.brakeCableNumberOfWiresAndCrossSectionSelection) ? state.brakeCableNumberOfWiresAndCrossSectionSelection.find(i => i.selected === true) || null : null;
    },
    brakeCableNumberOfWires: (state, getters, rootState, rootGetters) => {
        return getters.brakeCableNumberOfWiresAndCrossSection != null ? getters.brakeCableNumberOfWiresAndCrossSection.numberOfWires : null;
    },
    brakeCableCrossSection: (state, getters, rootState, rootGetters) => {
        return getters.brakeCableNumberOfWiresAndCrossSection != null ? getters.brakeCableNumberOfWiresAndCrossSection.crossSection : null;
    },
    brakeCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeCableBlockNumber != null ? getters.selectedBrakeCableBlockNumber.blockNumber : null;
    },
    brakeCableTypeDesignation: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeCableBlockNumber != null ? getters.selectedBrakeCableBlockNumber.typeDesignation.text : null;
    },
    brakeCableDeliver: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeCableDeliver != null && getters.selectedBrakeCableDeliver.text != null ? getters.selectedBrakeCableDeliver.text.code : null;
    },


    selectedBrakeMonitoringCableLength: (state, getters, rootState, rootGetters) => {
        return state.brakeMonitoringCableLengthSelection != null && Array.isArray(state.brakeMonitoringCableLengthSelection) ? state.brakeMonitoringCableLengthSelection.find(i => i.selected === true) || null : null;
    },
    selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return state.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection != null && Array.isArray(state.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection) ? state.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection.find(i => i.selected === true) || null : null;
    },
    selectedBrakeMonitoringCableSpecification: (state, getters, rootState, rootGetters) => {
        return state.brakeMonitoringCableSpecificationSelection != null && Array.isArray(state.brakeMonitoringCableSpecificationSelection) ? state.brakeMonitoringCableSpecificationSelection.find(i => i.selected === true) || null : null;
    },
    selectedBrakeMonitoringCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return state.brakeMonitoringCableBlockNumberSelection != null && Array.isArray(state.brakeMonitoringCableBlockNumberSelection) ? state.brakeMonitoringCableBlockNumberSelection.find(i => i.selected === true) || null : null;
    },
    selectedBrakeMonitoringCableDeliver: (state, getters, rootState, rootGetters) => {
        return state.cables_Data != null && state.cables_Data.hasOwnProperty('brakeMonitoringCable_DeliverOption_Valuelist') && Array.isArray(state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist) ? state.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist.find(i => i.selected === true) || null : null;
    },

    brakeMonitoringCableLength: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeMonitoringCableLength != null ? getters.selectedBrakeMonitoringCableLength.value : null;
    },
    brakeMonitoringCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide != null && getters.selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide.text != null ? getters.selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide.text.text : null;
    },
    brakeMonitoringCableSpecification: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeMonitoringCableSpecification != null && getters.selectedBrakeMonitoringCableSpecification.text != null ? getters.selectedBrakeMonitoringCableSpecification.text.text : null;
    },
    brakeMonitoringCableNumberOfWiresAndCrossSection: (state, getters, rootState, rootGetters) => {
        return state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection != null && Array.isArray(state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection) ? state.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection.find(i => i.selected === true) || null : null;
    },
    brakeMonitoringCableNumberOfWires: (state, getters, rootState, rootGetters) => {
        return getters.brakeMonitoringCableNumberOfWiresAndCrossSection != null ? getters.brakeMonitoringCableNumberOfWiresAndCrossSection.numberOfWires : null;
    },
    brakeMonitoringCableCrossSection: (state, getters, rootState, rootGetters) => {
        return getters.brakeMonitoringCableNumberOfWiresAndCrossSection != null ? getters.brakeMonitoringCableNumberOfWiresAndCrossSection.crossSection : null;
    },
    brakeMonitoringCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeMonitoringCableBlockNumber != null ? getters.selectedBrakeMonitoringCableBlockNumber.blockNumber : null;
    },
    brakeMonitoringCableTypeDesignation: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeMonitoringCableBlockNumber != null ? getters.selectedBrakeMonitoringCableBlockNumber.typeDesignation.text : null;
    },
    brakeMonitoringCableDeliver: (state, getters, rootState, rootGetters) => {
        return getters.selectedBrakeMonitoringCableDeliver != null && getters.selectedBrakeMonitoringCableDeliver.text != null ? getters.selectedBrakeMonitoringCableDeliver.text.code : null;
    },


    selectedForcedVentilationCableLength: (state, getters, rootState, rootGetters) => {
        return state.forcedVentilationCableLengthSelection != null && Array.isArray(state.forcedVentilationCableLengthSelection) ? state.forcedVentilationCableLengthSelection.find(i => i.selected === true) || null : null;
    },
    selectedForcedVentilationCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return state.forcedVentilationCableTypeOfConnectionOnComponentSideSelection != null && Array.isArray(state.forcedVentilationCableTypeOfConnectionOnComponentSideSelection) ? state.forcedVentilationCableTypeOfConnectionOnComponentSideSelection.find(i => i.selected === true) || null : null;
    },
    selectedForcedVentilationCableSpecification: (state, getters, rootState, rootGetters) => {
        return state.forcedVentilationCableSpecificationSelection != null && Array.isArray(state.forcedVentilationCableSpecificationSelection) ? state.forcedVentilationCableSpecificationSelection.find(i => i.selected === true) || null : null;
    },
    selectedForcedVentilationCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return state.forcedVentilationCableBlockNumberSelection != null && Array.isArray(state.forcedVentilationCableBlockNumberSelection) ? state.forcedVentilationCableBlockNumberSelection.find(i => i.selected === true) || null : null;
    },
    selectedForcedVentilationCableDeliver: (state, getters, rootState, rootGetters) => {
        return state.cables_Data != null && state.cables_Data.hasOwnProperty('forcedVentilationCable_DeliverOption_Valuelist') && Array.isArray(state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist) ? state.cables_Data.forcedVentilationCable_DeliverOption_Valuelist.find(i => i.selected === true) || null : null;
    },
    forcedVentilationCableLength: (state, getters, rootState, rootGetters) => {
        return getters.selectedForcedVentilationCableLength != null ? getters.selectedForcedVentilationCableLength.value : null;
    },
    forcedVentilationCableTypeOfConnectionOnComponentSide: (state, getters, rootState, rootGetters) => {
        return getters.selectedForcedVentilationCableTypeOfConnectionOnComponentSide != null && getters.selectedForcedVentilationCableTypeOfConnectionOnComponentSide.text != null ? getters.selectedForcedVentilationCableTypeOfConnectionOnComponentSide.text.text : null;
    },
    forcedVentilationCableSpecification: (state, getters, rootState, rootGetters) => {
        return getters.selectedForcedVentilationCableSpecification != null && getters.selectedForcedVentilationCableSpecification.text != null ? getters.selectedForcedVentilationCableSpecification.text.text : null;
    },
    forcedVentilationCableNumberOfWiresAndCrossSection: (state, getters, rootState, rootGetters) => {
        return state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection != null && Array.isArray(state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection) ? state.forcedVentilationCableNumberOfWiresAndCrossSectionSelection.find(i => i.selected === true) || null : null;
    },
    forcedVentilationCableNumberOfWires: (state, getters, rootState, rootGetters) => {
        return getters.forcedVentilationCableNumberOfWiresAndCrossSection != null ? getters.forcedVentilationCableNumberOfWiresAndCrossSection.numberOfWires : null;
    },
    forcedVentilationCableCrossSection: (state, getters, rootState, rootGetters) => {
        return getters.forcedVentilationCableNumberOfWiresAndCrossSection != null ? getters.forcedVentilationCableNumberOfWiresAndCrossSection.crossSection : null;
    },
    forcedVentilationCableBlockNumber: (state, getters, rootState, rootGetters) => {
        return getters.selectedForcedVentilationCableBlockNumber != null ? getters.selectedForcedVentilationCableBlockNumber.blockNumber : null;
    },
    forcedVentilationCableTypeDesignation: (state, getters, rootState, rootGetters) => {
        return getters.selectedForcedVentilationCableBlockNumber != null ? getters.selectedForcedVentilationCableBlockNumber.typeDesignation.text : null;
    },
    forcedVentilationCableDeliver: (state, getters, rootState, rootGetters) => {
        return getters.selectedForcedVentilationCableDeliver != null && getters.selectedForcedVentilationCableDeliver.text != null ? getters.selectedForcedVentilationCableDeliver.text.code : null;
    },

}

export const cables = {
    namespaced: true,
    components: {
        axios
    },
    state,
    actions,
    mutations,
    getters,
}